"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  buttons: {
    next: 'buttons-next',
    finish: 'buttons-finish',
    submit: 'buttons-submit',
    login: 'buttons-login',
    forgotPassword: 'buttons-forgot-password',
    confirm: 'buttons-confirm',
    submitClaim: 'buttons-submit-claim',
    submitStandardClaim: 'buttons-submit-standard-claim',
    submitHealthSpendingClaim: 'buttons-submit-health-spending-claim',
    submitLifestyleSpendingClaim: 'buttons-submit-lifestyle-spending-claim',
    cancel: 'buttons-cancel',
    back: "buttons-back",
    edit: "buttons-edit",
    yes: "buttons-yes",
    no: "buttons-no",
    save: "buttons-save",
    primary: "buttons-primary",
    contingent: "buttons-contingent",
    "save beneficiary": "buttons-save-beneficiary",
    remove: "buttons-remove",
    reassign: "buttons-reassign",
    "add trustee": "buttons-add-trustee",
    "claims summary": "buttons-claims-summary",
    getClaimsSummary: "buttons-get-claims-summary",
    filter: "buttons-filter",
    applied: "buttons-filters-applied",
    "get summary": "buttons-get-summary",
    'take photo': 'take-photo-button',
    'select photo': 'select-photo-button',
    'select pdf': 'select-pdf-button',
    subsequent: "subsequent-button-label",
    // Added "subsequent-button-label" here
    initial: "initial-button-label",
    editSubmission: "edit-submission-button",
    continueAnyway: "continue-anyway-button",
    addBankingDetails: 'buttons-add-banking-details',
    "done": 'buttons-done',
    "reset": 'buttons-reset',
    // Added line
    applyFilters: 'buttons-apply-filters',
    "pay now": 'buttons-pay-now',
    "go to store": 'buttons-go-to-store',
    "continue": 'buttons-continue',
    "add banking": 'buttons-add-banking',
    "purchase optional ci": 'buttons-purchase-optional-ci',
    editBankingDetails: 'buttons-edit-banking-details',
    saveBankingDetails: 'buttons-save-banking-details',
    'add beneficiary': 'buttons-add-beneficiary',
    // Added line
    'add contingent beneficiary': 'buttons-add-contingent-beneficiary',
    'save trustee': 'buttons-save-trustee',
    'download printable version': 'buttons-download-printable-version',
    'health claim': 'buttons-health-claim',
    // Added line
    'lifestyle claim': 'buttons-lifestyle-claim',
    download: 'buttons-download',
    downloadEOB: 'buttons-download-EOB',
    viewEOB: 'buttons-view-EOB',
    viewFiles: 'buttons-view-files',
    'download invoice pdf': 'download-invoice-pdf-button',
    'download invoice csv': 'download-invoice-csv-button',
    'refuse coverage': 'refuse-coverage-button',
    'view current usage': 'view-current-usage-button',
    'view last year': 'view-last-year-button',
    'select receipt': 'select-receipt-button',
    'select document': 'select-document-button',
    resetFilters: 'reset-filters-button',
    "back to mycard": "back-to-mycard-button",
    signIn: "sign-in-button",
    send: "send-button",
    close: 'close-button',
    downloadSalaryData: "download-salary-data-button",
    removeChange: "remove-change-button",
    details: "details-button",
    updateBankingDetails: "update-banking-details-button",
    downloadResources: "download-resources-button",
    downloadProofOfInsurance: "download-proof-of-insurance-button",
    downloadBenefitsCard: "download-benefit-card-button",
    generateEmployeeBooklet: "generate-employee-booklet-button",
    generating: "generating-button",
    downloadEmployeeBooklet: "download-employee-booklet-button",
    editDetails: "edit-details-button",
    doNotWaive: "do-not-waive-button",
    waive: "waive-button",
    terminate: "terminate-button",
    generate: "generate-button",
    sendForApproval: "send-for-approval-button",
    selectItems: "select-items-button",
    addToApplication: "add-to-application-button",
    "classes & divisions": "classes-&-divisions-button",
    downloadBlankTemplate: "download-blank-template-button",
    submitCensus: "submit-census-button",
    addCensusSheet: "add-census-sheet-button",
    saveCommissions: "save-commissions-button",
    createQuote: "create-quote-button",
    setQuoteBack: "set-quote-back-button",
    createDivision: "create-division-button",
    createClass: "create-class-button",
    add: "buttons-add",
    bankingDetails: "banking-details-button",
    editDivision: "edit-division-button",
    newDivision: "new-division-button",
    downloadCarrierPackage: "download-carrier-package-button",
    convertQuote: "convert-quote-button",
    imInterested: "im-interested-button",
    optOut: "opt-out-button",
    maybeLater: "maybe-later-button",
    moreDetails: "more-details-button",
    purchased: "purchased-button",
    buyForDependents: "buy-for-dependents-button",
    buy: "buy-button",
    confirmPurchase: "confirm-purchase-button",
    completePurchase: "complete-purchase-button",
    notify: "notify-button",
    saveAndSubmit: "save-and-submit-button",
    backToEdit: "back-to-edit-button",
    downloadPlanDesign: "plan-design-button",
    downloadPlanPricing: "plan-pricing-button",
    downloadCsv: "download-csv-button",
    downloadPdf: "download-pdf-button",
    downloadDivisionSummary: "download-division-summary-label",
    downloadPayrollDeductions: "download-payroll-deductions",
    requestReview: "request-review-button",
    rejectPricing: "reject-pricing-button",
    downloadClassBooklet: "download-class-booklet-button",
    navigateToHome: "navigate-to-home-button",
    navigateToMyAccount: "navigate-to-my-account-button",
    navigateToSupport: "navigate-to-support-button",
    logout: "logout-button",
    approveAmendment: "approve-amendment-button",
    revert: "revert-button",
    view: "view-button",
    createFolder: "create-folder",
    uploadFile: "upload-file",
    create: "create-button"
  },
  titles: {
    home: 'titles-home',
    "benefits card": 'titles-benefits-card',
    spendingAccounts: 'titles-spending-accounts',
    "claims history": 'titles-claims-history',
    claims: 'titles-claims',
    usage: 'titles-usage',
    coverage: 'titles-coverage',
    accountDetails: 'titles-account-details',
    resources: "titles-resources",
    support: "titles-support",
    "terms of service": "titles-terms-of-service",
    privacyNotice: "titles-privacy-notice",
    "my account": "titles-my-account",
    bankingDetails: "titles-banking-details",
    currentBankingDetails: "titles-current-banking-details",
    reimbursementAccount: "titles-reimbursement-account",
    reimbursementAccountDetails: "titles-reimbursement-account-details",
    premiumPaymentAccount: "titles-premium-payment-account",
    premiumPaymentAccountDetails: "titles-premium-payment-account-details",
    changePassword: "titles-change-password",
    dependents: "titles-dependents",
    beneficiaries: "titles-beneficiaries",
    trustee: "titles-trustee",
    logout: "titles-logout",
    "terms of use": "titles-terms-of-use",
    hello: "titles-hello",
    "protect yourself with ci": "titles-protect-yourself-with-ci",
    presentThisCard: "titles-present-this-card",
    my: "titles-my",
    card: "titles-card",
    carrier: "titles-carrier",
    "policy no": "titles-policy-no",
    "cert no": "titles-cert-no",
    drugs: "titles-drugs",
    ehc: "titles-ehc",
    dental: "titles-dental",
    "class": "titles-class",
    division: "titles-division",
    benefit: "titles-benefit",
    status: "titles-status",
    "emergency travel assist": "titles-emergency-travel-assist",
    "24 7 medical": "titles-24-7-medical",
    "please call within 24 hours": "titles-please-call-within-24-hours",
    "in canada or usa": "titles-in-canada-or-usa",
    internationally: "titles-internationally",
    "ooc policy no": "titles-ooc-policy-no",
    "ooc provider": "titles-ooc-provider",
    "prescription drug card": "titles-prescription-drug-card",
    "for use in": "titles-for-use-in",
    "canada only": "titles-canada-kit",
    "pharmacy call center services": "titles-pharmacy-call-center-services",
    "going to dentist or pharmacy": "titles-dental-or-pharmacy",
    "pocketpills online pharmacy": "titles-pocketpills-online-pharmacy",
    efap: "titles-efap",
    "how to submit claim": "titles-how-to-submit-claim",
    "cost saving strategies": "titles-cost-saving-strategies",
    "optional ci overview": "titles-optional-ci-overview",
    "gotodoctor signup": "titles-gotodoctor-signup",
    "oop coverage info": "titles-oop-coverage-info",
    "aig travel assist": "titles-aig-travel-assist",
    "primary beneficiaries": "titles-primary-beneficiaries",
    "contingent beneficiaries": "titles-contingent-beneficiaries",
    "add beneficiary": "titles-add-beneficiary",
    "edit beneficiary": "titles-edit-beneficiary",
    "remove beneficiary": "titles-remove-beneficiary",
    "my trustee": "titles-my-trustee",
    "remove trustee": "titles-remove-trustee",
    "add trustee": "titles-add-trustee",
    "edit trustee": "titles-edit-trustee",
    "optional benefits": "titles-optional-benefits",
    "optional benefits coverage": "titles-optional-benefits-coverage",
    "claims summary": "titles-claims-summary",
    "submit claim": "titles-submit-claim",
    lifestyleSpending: "dropdowns-lifestyle-spending",
    healthSpending: "dropdowns-health-spending",
    'cancel claim': "cancel-claim-title",
    "remove photo": "remove-photo-title",
    "your usage": "your-usage-title",
    majorMedical: "major-medical-title",
    vision: "vision-title",
    paramedicals: "paramedicals-title",
    "your plan": "your-plan-title",
    noCoverage: "no-coverage-title",
    longTermDisability: "long-term-disability-title",
    shortTermDisability: "short-term-disability-title",
    criticalIllness: "critical-illness-title",
    "employee assistance program": "employee-assistance-program-title",
    employeeAssistance: "employee-assistance-title",
    virtualHealthCare: "virtual-healthcare-title",
    "out of province country": "out-of-province/country-title",
    outOfCountry: "out-of-country-title",
    lifeInsurance: "life-insurance-title",
    "ad&d": "ad&d-title",
    gradedCoverage: "graded-coverage-title",
    flatAmountCoverage: "flat-amount-coverage-title",
    dependentLife: 'titles-dependent-life',
    resetPassword: 'titles-reset-password',
    "help": 'titles-help',
    "dashboard": 'titles-dashboard',
    "my usage": 'titles-my-usage',
    noBankingData: 'titles-no-banking-data',
    "protect yourself optional critical illness coverage": 'titles-protect-critical-illness',
    "invoices": 'titles-invoices',
    "prescription delivery": 'titles-prescription-delivery',
    'update credit card': 'titles-update-credit-card',
    'update account details': 'titles-update-account-details',
    updatePasswordAfterReset: 'titles-update-password-after-reset',
    'confirm changes': 'titles-confirm-changes',
    'add dependent': 'titles-add-dependent',
    // Added line
    'edit dependent': 'titles-edit-dependent',
    "claim summary": 'titles-claim-summary',
    "claim pending": 'titles-claim-pending',
    accidentalDeathAndDismemberment: 'titles-accidental-death-dismemberment',
    "out of country or province": 'titles-out-of-country-or-province',
    'aig travel guard assistance': 'titles-aig-travel-guard-assistance',
    'my plan coverage': 'titles-my-plan-coverage',
    'confirm banking details': 'titles-confirm-banking-details',
    'invoice history': 'titles-invoice-history',
    'no invoice history': 'titles-no-invoice-history',
    'forms and booklets': 'titles-forms-and-booklets',
    'notifications': 'titles-notifications',
    'tip': 'titles-tip',
    'details': 'titles-details',
    areYouSure: 'are-you-sure-title',
    'set spending account maximums': 'set-spending-account-maximums',
    employees: 'employees-title',
    massSalaryUpdate: "mass-salary-update-title",
    setEffectiveDate: "set-effective-date-title",
    changeLog: "changelog-title",
    pendingChanges: "pending-changes-label",
    waivedCoverage: "waived-coverage-label",
    healthAndDental: "health-and-dental-label",
    waivedCoverageFor: "waived-coverage-for-label",
    latestChanges: 'latest-changes-label',
    healthcare: "healthcare-title",
    employeeFamilyAssistance: "employee-family-assistance-title",
    contactSupport: "contact-support-title",
    summary: "summary-title",
    criticalIllnessSpouse: "critical-illness-spouse-title",
    criticalIllnessChild: "critical-illness-child-title",
    hsa: "hsa-title",
    lsa: "lsa-title",
    stopLoss: "stop-loss-title",
    ltd: "ltd-title",
    std: "std-title",
    depLife: "dep-life-title",
    ci: "ci-title",
    ciSpouse: "ci-spouse-title",
    ciChild: "ci-child-title",
    health: "health-title",
    optional: "optional-title",
    voluntary: "voluntary-title",
    optionalBenefits: "optional-benefits-title",
    voluntaryBenefits: "voluntart-benefits-title",
    misc: "misc-title",
    miscPremiums: "misc-premiums-title",
    costPlus: "cost-plus-title",
    quotes: "quotes-title",
    pendingAccounts: "pending-accounts-title",
    activeAccounts: "active-accounts-title",
    lostOpportunities: "lost-opportunites-title",
    underAmendment: "under-amendment-title",
    commissions: "comissions-title",
    classesAndDivisions: "classes-and-divisions-title",
    accountHistory: "account-history-title",
    planDesign: "plan-design-title",
    masterApplication: "master-application-title",
    pricing: 'pricing-title',
    sendForUnderwriting: "send-for-underwriting-title",
    assignPlans: "assign-plans-title",
    requestApproval: "request-approval-title",
    underwritingQuote: "underwriting-quote-title",
    census: "census-title",
    goLive: "go-live-title",
    amendments: "amendments-title",
    classBooklets: "class-booklets-title",
    modifyAccountDetails: "modify-account-details-title",
    commissionsBreakdown: "commissions-breakdown-title",
    commissionAssignment: "commission-assignment-title",
    employeeFamilyAssistanceProgram: "employee-family-assistance-program-label",
    editDivision: "edit-division-title",
    newDivision: "new-division-title",
    editClass: "edit-class-title",
    newClass: "new-class-title",
    settings: "settings-title",
    planAssign: "plan-assign-title",
    paramedical: "paramedical-title",
    outOfCountryAndProvince: "out-of-country-and-province-title",
    areYouInterested: "are-you-interested-title",
    marketplace: "marketplace-title",
    planPricing: "plan-pricing-title",
    divisionBankingDetails: "division-banking-details-title",
    banking: "banking-title",
    proofOfInsurance: "proof-of-insurance-title",
    claimSummaryReport: "claim-summary-report-title",
    productTerminationBlockedTitle: "termination-blocked-modal-title",
    invoiceDate: "invoice-date-label",
    specialityProductRates: "speciality-product-rates",
    planDesignAssignment: "plan-design-assignment-title",
    pricingRejection: "pricing-rejection-title",
    design: "designs-title",
    editDetails: "edit-details-titles",
    createQuote: "create-quote-title",
    revisions: "revision-title",
    basicLife: "basic-life-title",
    files: "files-title",
    financialAwareness: "financial-awareness-title"
  },
  labels: {
    firstname: 'firstname-label',
    lastname: 'lastname-label',
    email: 'email-label',
    birthdate: "birthdate-label",
    password: 'password-label',
    streetAddress: 'street-address-label',
    address: 'address-label',
    unit: 'unit-label',
    city: 'city-label',
    province: 'province-label',
    postalCode: 'postal-code-label',
    phoneNumber: 'phone-number-code-label',
    maritalStatus: 'marital-status-label',
    gender: 'gender-label',
    coverageType: 'coverage-type-label',
    yourName: "your-name-label",
    signature: "signature-label",
    relationship: "relationship-label",
    updateAccountDetails: "update-account-details-label",
    pleaseConfirmDetailsError: "please-confirm-account-details-error-label",
    datedOn: "dated-on-label",
    type: "type-label",
    year: "year-label",
    or: "or-label",
    amountRemaining: "amount-remaining-label",
    submitClaim: 'labels-submit-claim',
    purchaseOptionalBenefits: 'labels-purchase-optional-benefits',
    maximum: 'maximum-label',
    noTrustee: "no-trustee-label",
    "health": 'labels-health',
    "lifestyle": 'labels-lifestyle',
    total: 'labels-total',
    confirmation: 'confirmation-label',
    effectiveDate: "effective-date-label",
    changesAppliedOnEffectiveDate: "changes-applied-on-effective-date-label",
    pleaseProvideEffectiveDate: "please-provide-effective-date-label",
    search: "seach-label",
    months: "months-label",
    certificateNumber: "certificate-number-label",
    groupNumber: "group-number-label",
    "class": "class-label",
    classDescription: "class-description-label",
    division: "division-label",
    active: "active-label",
    inactive: "inactive-label",
    status: "status-label",
    certificate: "certificate-label",
    lossRatioFileName: "loss-ratio-file-name-label",
    ltdFileName: "ltd-file-name-label",
    asoFileName: "aso-file-name-label",
    invoiceFileName: "invoice-file-name-label",
    benefitCardFileName: "benefit-card-file-name-label",
    proofFileName: "proof-file-name-label",
    planDesignFileName: "plan-design-file-name-label",
    planPricingFileName: "plan-pricing-file-name-label",
    massSalaryDownloadFileName: "mass-salary-download-file-name-label",
    specialityProductRatesTileDesc: "speciality-product-rates-tile-label",
    completed: "step-completed-label",
    notFound: "not-found-label",
    internalError: "internal-error-label",
    yes: "yes-label",
    no: "no-label",
    banking: {
      accountHolderName: "account-holder-name-label",
      validateBanking: "validate-banking-label",
      financialInstitutionNumber: "financial-institution-number-label",
      branchTransitNumber: "branch-transit-number-label",
      accountNumber: "account-number-label",
      changeBankingDetails: 'change-banking-details-label',
      threeDigits: "three-digits-label",
      fiveDigits: "five-digits-label",
      ifItStartsWithZeroInclude: "if-it-starts-with-zero-include-label",
      legalAccessVerbiageBoth: "both-withdraw-and-deposit-to-label",
      legalAccessVerbiageDeposit: "deposit-to-label",
      legalAccessVerbiageWithdraw: "withdraw-from-label",
      asItAppearsOnYourCheque: "as-it-appears-on-your-cheque-label",
      youHaveAlreadySubmittedBankingDetails: 'you-have-already-submitted-banking-details-label',
      exampleFollowingInformationFoundoOnCheque: "example-following-info-found-on-cheque-label",
      wouldYouLikeToUseTheSameBankAccounts: "would-you-like-to-use-the-same-bank-account-label",
      financialInstitutionNumberError: "financial-institution-number-error-label",
      transitNumberError: "transit-number-error-label",
      transitNumberValidationError: "transit-number-validation-error-label",
      bankDetailsValidationError: "bank-details-validation-error-label",
      financialInstitutionNumberValidationError: "financial-institution-number-validation-error-label",
      haveVerifiedBankingInformation: "have-verified-banking-information-label",
      pleaseSelect: "please-select-label",
      youMustAcceptTermsError: "you-must-accept-terms-error-label",
      primaryAccountHolderBanking: 'primary-account-holder-banking-label',
      pleaseEnsureYourInformationIsCorrect: "please-ensure-your-information-is-correct-labels",
      ensureDepositInformationIsCorrect: "please-ensure-your-deposit-information-is-correct-labels",
      followingInformationFoundOnCheque: 'labels-banking-info',
      enterFinancialInstitutionNumberFirst: 'labels-enter-fi-number-first',
      example: 'labels-example',
      accountPassword: 'account-password-label',
      paymentSelection: 'payment-selection-label',
      youHaveBeenGivenA: 'given-a-label',
      payByMember: 'pay-by-member-label',
      benefitsAccountResponsibilityAndPaymentSelection: 'benefits-account-responsibility-payment-label',
      creditCardFeeNote: 'credit-card-fee-note-label',
      directDebit: 'direct-debit-label',
      creditCard: 'credit-card-label',
      benefitsAccountResponsibility: 'benefits-account-responsibility-label',
      bankingDetailsRequest: 'banking-details-request-label',
      chequeAndPersonalBankingWebsiteInformation: 'cheque-banking-website-info-label',
      bankAccountForReimbursementsAndPremiumPayments: 'bank-account-reimbursements-premium-label',
      legalAccessVerbiageAccount: "legal-access-verbiage-account-label",
      override: "override-banking-label",
      pleaseEnsureDivisionBankingInfoCorrect: "please-ensure-division-banking-info-correct-label",
      enterSimplyBenefitsPassword: "enter-simply-benefits-password-label",
      provideSignatureToContinue: "provide-signature-continue-label",
      successfullySubmittedBankingDetails: "successfully-submitted-banking-details-label",
      viewDivisionBankingDetails: "view-division-banking-details-label",
      youHaveProvidedTheFollowing: "you-have-provided-the-following-label",
      ensureInformationCorrectDeposit: "ensure-information-correct-deposit-label",
      notCorrect: "not-correct-banking-label",
      editThisInformation: "edit-this-information-banking-label",
      validateBranchDetails: "validate-branch-details-label",
      validating: "banking-validating-label",
      branchValidationFailed: "branch-validation-failed-label",
      youMustValidateYourDetailsBeforeContinuing: "you-must-validate-your-details-before-continuing-label",
      bankingValidationFailed: "banking-validation-failed-label",
      providedBankCouldNotBeValidated: "provided-bank-could-not-be-validated-label"
    },
    signage: {
      pleaseEnterAccountPasswordLabel: "please-enter-account-password-label",
      pleaseAcceptAndAcknowledgeChanges: "please-accept-and-acknowledge-changes-labels",
      signageNameError: "signage-name-error-label",
      advisorSignageError: "advisor-signage-error-label",
      authoritySignageError: "authority-signage-error-label"
    },
    beneficiaries: {
      youHaveNotDefinedAnyPrimaryBeneficiaries: 'labels-no-primary-beneficiaries',
      youHaveNotDefinedAnyContingentBeneficiaries: 'labels-no-contingent-beneficiaries',
      youHaveNoPrimaryBeneficiaries: "you-have-no-primary-beneficiaries-label",
      youHaveNoContingentBeneficiaries: "you-have-no-contingent-beneficiaries-label",
      chooseBeneficiaryType: "choose-beneficiary-type-label",
      pleaseEnsureAllContingentBeneficiaries: "please-ensure-all-contingent-beneficiaries-labels",
      pleaseEnsureAllPrimaryBeneficiaries: "please-ensure-all-primary-beneficiaries-labels",
      newBeneficiaryPercentage: "new-beneficiary-percentage-label",
      sharesPercentage: "shares-percentage-label",
      beneficiaryUnderEighteenError: "beneficiary-under-eighteen-error-label",
      percentOfBenefits: "percent-of-benefit-label",
      sharesMustEqualError: "shares-must-equal-error-label",
      primary: "primary-label",
      contingent: "contingent-label",
      percentageOfBenefits: "percentage-of-benefits-label",
      contingentSharesEqual: "contingent-shares-equal-label",
      primarySharesEqual: "primary-shares-equal-label",
      addContingentBeneficiaryToHealthPlan: 'add-contingent-beneficiary-label',
      addBeneficiaryToHealthPlan: 'add-beneficiary-label',
      allSharesCollectivelyEqual: 'shares-collectively-100-percent-label',
      revocable: 'revocable-label'
    },
    constants: {
      termsAndConditions: "terms-and-conditions-label",
      privacyPolicy1: "privacy-policy-one-label",
      whatWeCollect: "what-we-collect-label",
      requiredRegulatoryInformation: "required-regulatory-information-label",
      yourNameAndDateOfBirth: "your-name-and-date-of-birth-label",
      collectedInformationList: "collected-information-list-label",
      weMayReceivePassivelyCollectedInformation: "we-may-receive-passively-collected-information-label",
      whatIsACookie: "what-is-a-cookie-label",
      cookiesDescription: "cookies-description-label",
      optingOutOfCookies: "opting-out-of-cookies-label",
      optingOutOfCookiesDescription: "opting-out-of-cookies-description-label",
      analyticsAndMarketing: "analytics-and-marketing-labels",
      analyticsAndMarketingDescription: "analytics-and-marketing-description-label",
      whereDoWeStore: "where-do-we-store-label",
      whereDoWeStoreDescription: "where-do-we-store-description-label",
      howWeUseIt: "how-we-use-it-label",
      howWeUseItDescription: "how-we-use-it-description-label",
      howWeProtectIt: "how-we-protect-it-label",
      howWeProtectItDescription: "how-we-protect-it-description-label",
      privacyPolicy2: "privacy-policy-two-label"
    },
    changePassword: {
      existingPassword: "existing-password-label",
      newPassword: "new-password-label",
      confirmPassword: "confirm-password-label",
      newPasswordConfirmError: "new-password-confirm-error-label",
      passwordSentInEmail: 'labels-password-sent-in-email'
    },
    validations: {
      pleaseEnterValidNumber: "enter-valid-number-label",
      enterBirthDate: "enter-birth-date-label",
      yourPasswordMustBeAtLeast6Characters: 'labels-password-min-6-characters',
      pleaseEnterAValidName: 'labels-enter-valid-name',
      pleaseProvideARelationship: 'labels-provide-relationship',
      // Added line
      pleaseProvideACategory: 'labels-provide-category',
      // Added line
      pleaseProvideAPercentageOfShares: 'labels-provide-shares',
      pleaseEnterAValue: 'labels-enter-a-value',
      validEmailAddress: 'labels-valid-email-address',
      passwordValidation: 'labels-password-validation',
      relationshipToDependent: 'relationship-to-dependent-label',
      spousesEmployer: 'spouses-employer-label',
      accountIdentifierInvalidLabel: 'account-identifier-invalid-label',
      userIdentifierInvalidLabel: 'user-identifier-invalid-label',
      firstNameLabel: 'first-name-label',
      lastNameLabel: 'last-name-label',
      spousesGroupBenefitsInsuranceCarrier: 'spouses-group-benefits-insurance-carrier-label',
      provinceOfResidence: 'province-of-residence-label',
      provideGender: 'provide-gender-label',
      validPhoneNumber: 'valid-phone-number-label',
      coverageType: 'coverage-type-selection-label',
      validPercentageAmountOfShares: 'valid-percentage-amount-of-shares-label',
      validCreditCard: 'valid-credit-card-label',
      contactEmailAddress: 'contact-email-label',
      messageForYourNotification: 'message-for-notification-label',
      supportRequestSubjectLabel: 'support-request-subject-label',
      validSupportRequestSubjectLabel: 'valid-support-request-subject-label',
      supportRequestDescriptionLabel: 'support-request-description-label',
      validSupportRequestDescriptionLabel: 'valid-support-request-description-label',
      pleaseEnterAPassword: 'enter-password-label',
      enterValueLabel: 'enter-value-label',
      provideValueLabel: 'provide-value-label',
      validAddressLabel: 'valid-address-label',
      validMunicipalityLabel: 'valid-municipality-label',
      validDollarAmountTo2DecimalPlaces: 'dollar-amount-label',
      validPercentageNoMoreThan100To2DecimalPlaces: 'percentage-label',
      pleaseEnterACompanyAddress: 'company-address-label',
      onlyOneCompanyName: 'one-company-name-label',
      doNotEnterAnySpecialCharacters: 'no-special-characters-label',
      onlyYourOfficialName: 'official-name-label',
      oneOfficialFirstAndLastName: 'official-name-label',
      doNotUseSubsequentCapitalLetters: 'no-subsequent-capital-letters-label',
      hireDate: 'hire-date-label',
      maritalStatusValidation: 'marital-status-validation-label',
      genderValidation: 'gender-validation-label',
      occupation: 'occupation-label',
      coverageTypeValidation: 'coverage-type-validation-label',
      provinceResidence: 'province-residence-label',
      earningsType: 'earnings-type-label',
      annualSalary: 'annual-salary-label',
      hourlyWage: 'hourly-wage-label',
      hoursPerWeek: 'hours-per-week-label',
      postalCodeValidation: 'postal-code-validation-label',
      enterBirthdateLabel: "enter-birthdate-label",
      enterEmailLabel: "enter-email-label",
      enterPasswordLabel: "enter-password-label",
      passwordRequirementsLabel: "password-requirements-label",
      validBirthdateLabel: "valid-birthdate-label",
      validDateLabel: "valid-date-label",
      validEmailAddressLabel: "valid-email-address-label",
      fileCorrupt: "file-corrupt-label",
      fileAlreadySelected: "file-already-selected-label",
      pleaseSelectAtLeastOne: "select-at-least-one-label",
      existingCarrier: "add-existing-carrier-label",
      bankingDetailsCorrectlyFilledOut: "banking-details-correctly-filled-out-label",
      oneChoice: "one-choice-label",
      emailAddressCannotContainAccents: "email-address-cannot-contain-accents-validations-label",
      childDependentsUnder26: "child-dependents-under-26-label",
      amountSubmittedGreaterThanZero: "amount-submitted-greater-than-zero-label",
      firstAndLastName: "pleae-enter-first-and-last-label",
      selectClass: 'select-a-class-label',
      selectDivision: 'select-a-division-label',
      selectLanguage: 'select-a-language-label'
    },
    dashboard: {
      welcomeToYourPersonalHealthDashboard: "welcome-to-your-personal-health-dashboard-label",
      latestClaims: "latest-claims-label",
      recentUsage: "recent-usage-label",
      youHaveNotMadeAnyClaims: "you-have-not-made-any-claims-label",
      noRecentUsage: "no-recent-usage-label",
      protectYourselfWithCI: "protect-yourself-with-ci-label",
      purchaseOptionalCI: "purchase-optional-ci-label",
      newAppUpdate: 'labels-new-app-update',
      newAppUpdateMessage: 'labels-new-app-update-message',
      goodMorning: 'labels-good-morning',
      goodAfternoon: 'labels-good-afternoon',
      goodEvening: 'labels-good-evening',
      personalizedHealthDashboard: 'labels-personalized-health-dashboard',
      makeAClaimOrViewClaimsHistory: 'labels-make-claim-view-claims-history',
      seeYourHealthAndLifestyleAccountBalances: 'labels-see-account-balances',
      viewYourCoverageUsageAndRemainingBalances: 'labels-view-usage-remaining-balances',
      viewYourBenefitsCard: 'labels-view-benefits-card',
      viewAndManageAccountDetails: 'labels-view-manage-account-details',
      viewABreakdownOfYourPlanCoverages: 'labels-view-plan-coverages',
      welcome: 'labels-welcome',
      optionalCriticalIllnessCoverage: 'labels-optional-critical-illness-description',
      forgotPassword: 'labels-forgot-password',
      resetPasswordConfirmation: 'labels-reset-password-confirmation',
      mainAccountHolderNoPaymentSetup: 'labels-main-acct-no-payment',
      // Added line
      youNoPaymentSetup: 'labels-you-no-payment',
      advisorLogin: "advisor-login-label",
      adminLogin: "admin-login-label",
      areYouAnAdminLogin: "are-you-an-admin-login-label",
      areYouAnAdvisorLogin: "are-you-an-advisor-login-label",
      accountToBeTerminated: "account-to-be-terminated-label",
      thisAccountWillBeTerminatedOn: 'this-account-will-be-terminated-on-label',
      benefitsCardNote: "benefits-card-note-label",
      marketplaceDetails: "marketplace-details-label"
    },
    resources: {
      pocketPillsOnlinePharmacyDetails: "pocketpills-online-pharmacy-details-label",
      prescriptionDeliveryRightToYourDoor: "prescription-delivery-right-to-your-door-label",
      employeeFamilyAssistanceProgram: "employee-and-family-assistance-program-label",
      virtualHealthcareServices: "virtual-healthcare-services-label",
      pdfClaimGuide: "step-by-step-pdf-guide-label",
      guideToSaveMoney: "guide-to-save-money-label",
      optionalCIBrochure: "optiona-ci-brochure-label",
      goToDoctorCoverage: "gotodoctor-label",
      goToDoctorSignup: "gotodoctor-signup-label",
      oopDetails: "oop-details-label",
      oopDetailsAig: "oop-details-aig-label",
      whenFormsAndDocumentsAreAvailable: 'when-forms-and-documents-are-available',
      yourBookletIsBeingGenerated: 'booklet generation label',
      bookletDownloading: 'booklet downloading label',
      employeeBooklet: 'employee booklet label',
      humanacareEmployeeAndFamilyAssistance: 'humanacare employee family assistance label',
      dialogueEmployeeAndFamilyAssistance: 'dialogue employee family assistance label',
      mapleVirtualHealthcare: 'maple virtual healthcare label',
      gotodoctorVirtualHealthcare: 'gotodoctor virtual healthcare label',
      gotodoctorSignup: 'gotodoctor signup label',
      dialogueVirtualHealthcare: 'dialogue virtual healthcare label',
      costSavingStrategies: 'cost saving strategies label',
      featuresAndDetailsOfYourCoverage: 'coverage features details label',
      detailsOfYourEmployeeAndFamilyAssistanceCoverage: 'employee family assistance details label',
      detailsOfYourMedicalSecondOpinionCoverage: 'medical second opinion details label',
      detailsOfYourMapleCoverage: 'maple coverage details label',
      detailsOfYourGotodoctorCoverage: 'gotodoctor coverage details label',
      signUpWithGotodoctor: 'signup with gotodoctor label',
      detailsOfYourDialogueCoverage: 'dialogue coverage details label',
      detailsOfYourAccessToPocketpillsOnlinePharmacy: 'pocketpills access details label',
      aGuideOnHowToSaveMoneyWhenUsingEmployeeBenefits: 'money saving employee benefits guide label',
      secondOpinion: 'second opinion label',
      maternityPaternityLeaveForm: "maternity-paternity-leave-form-label",
      forEmployeeCommencingMaternity: "for-employee-commencing-maternity-label",
      extendedHealthClaimsSubmissionForm: "extended-health-claims-submission-form-label",
      forMedicalExpensesAndServices: "for-medical-expenses-and-services-label",
      dentalClaimsSubmissionForm: "dental-claims-submission-form-label",
      forDentalExpensesAndServices: "for-dental-expenses-and-services-label",
      disabledChildDependentForm: "disabled-child-dependent-form-label",
      forEmployeesWithDisabledChild: "for-employees-with-disabled-child-label",
      studentDeclarationForm: "student-declaration-form-label",
      forEmployeesWithDepsOver21: "for-employes-with-dependents-over-21-label",
      noticeOfAbsenceForm: "notice-of-absence-form-label",
      forEmployeesOffWorkMoreThan10Days: "for-employees-off-work-more-than-10-days-label",
      groupChangeForm: "group-change-form-label",
      forInsuredEmployeeChanges: "for-insured-employee-changes-label",
      onceFormsAreCompletedAndSigned: "once-forms-are-completed-and-signed-label",
      spendingAccountProposalTemplate: "spending-account-proposal-template-label",
      insertClientDetails: "insert-client-details-label"
    },
    dependents: {
      contactPlanAdmin: "contact-plan-admin-label",
      youHaveNoDependents: "you-have-no-dependents-label"
    },
    claims: {
      amountClaimed: "amount-claimed-label",
      amountSubmitted: "amount-submitted-label",
      allYears: "all-years-label",
      claimID: "claim-id-label",
      submitted: "submitted-label",
      declined: 'declined-label',
      pending: "pending-label",
      noSummaryAvailable: "no-summary-label",
      recentClaims: "recent-claims-label",
      serviceDate: "service-date-label",
      noResultsFound: "no-results-found-label",
      clearFilters: "clear-filters-label",
      submitStandardClaim: "submit-standard-claim-label",
      submitHealthSpendingClaim: "submit-health-spending-claim-label",
      submitLifestyleSpendingClaim: "submit-lifestyle-spending-claim-label",
      patient: "patient-label",
      service: "service-label",
      category: "category-label",
      quickReimbursement: "quick-reimbursement-label",
      clinicNameLabel: "clinic-name-label",
      claimAgreementScreen1: "claim-agreement-screen-one-label",
      claimAgreementScreen2: "claim-agreement-screen-two-label",
      submitClaimAcknowledgment: "submit-claim-acknowledgment-label",
      cancelClaimConfirmation: "cancel-claim-confirmation-label",
      provideHealthReceipt: "provide-health-receipt-label",
      provideReceipt: "provide-receipt-label",
      providePhotoReceipt: "provide-photo-receipt-label",
      missingCameraPermissions: "Missing camera or camera roll permissions. Please contact support for assistance.",
      missingDocumentPermissions: "Missing document or document picker permissions. Please contact support for assistance.",
      removeImageFromSupportingDocs: "remove-image-from-supporting-docs-label",
      provideOtherDocuments: "provide-other-documents-label",
      provideSupportingDocumentsPhotos: "provide-supporting-documents-photos-label",
      reviewClaimDetails: "review-claim-details-label",
      typeOfVisit: "type-of-visit-label",
      serviceOver60Mins: "service-over-60-mins-label",
      acknowledgeCorrectInfo: "acknowledge-correct-info-label",
      serviceLength: "service-length-label",
      firstSubmitClaims: 'submit-claims-before-health-spending-account-label',
      receiptPhotoPrompt: 'receipt-photo-prompt-label',
      bankingDetailsNotSetUp: 'labels-banking-details-not-set-up',
      receiptInvoice: "receipt-invoice-label",
      // Added "receipt-invoice-label" here
      clinic: "clinic-label",
      amount: "amount-label",
      supportingDocuments: "supporting-documents-label",
      quickReimbursementNote: "quick-reimbursement-note-label",
      confirmContinue: "confirm-continue-label",
      noSupportingDocuments: "labels-no-supporting-documents",
      claimDetails: "labels-claim-details",
      claimCompleted: "labels-claim-completed",
      claimIdentifier: "labels-claim-identifier",
      serviceType: 'labels-service-type',
      allServiceTypes: 'labels-all-service-types',
      yearServiceDate: 'labels-year-service-date',
      sortBy: 'labels-sort-by',
      sortDirection: 'labels-sort-direction',
      oldestFirst: 'labels-oldest-first',
      newestFirst: 'labels-newest-first',
      filterAndSortClaims: 'labels-filter-and-sort-claims',
      submissionDate: 'labels-submission-date',
      allCategories: 'labels-all-categories',
      allPatients: 'labels-all-patients',
      selectPatient: 'select-patient-label',
      selectService: 'select-service-label',
      selectCategory: 'select-category-label',
      selectYear: 'select-year-label',
      identifier: 'identifier-label',
      status: 'status-label',
      noLifestyleClaims: 'no-lifestyle-claims-label',
      dateRange: 'date-range-label',
      getClaimsSummary: 'get-claims-summary-label',
      dates: 'dates-label',
      pleaseProvideValidDateRange: 'please-provide-valid-date-range-label',
      claimStatusMessage: 'claim-status-message-label',
      hideReceipt: 'hide-receipt-label',
      showReceipt: 'show-receipt-label',
      noClaimHistory: 'no-claim-history-label',
      submitClaimButton: 'submit-claim-button-label',
      referToYourBooklet: 'refer-to-booklet-label',
      areYouSureYouWantToCancelTheClaim: 'cancel-claim-confirmation-label',
      claimed: 'claimed-label',
      noLifestyleSpendingServicesDefined: 'no-lifestyle-spending-services-defined-label',
      claimAlreadySubmittedToOtherInsurer: 'claim-already-submitted-other-insurer-label',
      claimAmountDetails: 'claim-amount-details-label',
      wantATopOff: 'want-a-top-off-label'
    },
    coverage: {
      combinedMax: "combined-max-label",
      majorMaxAmount: "major-max-amount-label",
      basicMaxAmount: "basic-max-amount-label",
      unlimited: "unlimited-label",
      daysLimit: "days-limit-label",
      wantToKnowWhatsCovered: "want-to-know-whats-covered-label",
      askAwayWellAnswer: "ask-away-well-answer-label",
      isMassageCovered: "is-massage-covered-label",
      coverageWaivedMessage: "coverage-waived-message-label",
      ineligibleForBenefit: "ineligible-for-benefit-label",
      ltdEligibilityDescription: "ltd-eligibility-description-label",
      percentageOfFlatAmount: "percentage-of-flat-amount-label",
      taxable: "taxable-label",
      nonTaxable: "non-taxable-label",
      maxWithEvidence: "max-with-evidence-label",
      maxNoEvidence: "max-without-evidence-label",
      benefitsPeriod: "benefits-period-label",
      dayEliminationPeriod: "elim-period-label",
      definitionOfDisability: "disability-definition-label",
      terminatesAtAge: "terminates-at-age-label",
      costOfLivingAdjToDisability: "cost-of-living-adj-label",
      allowPreexistingConditions: "allow-preexisting-label",
      lumpSumPayment: "lump-sum-payment-label",
      waivedBenefitForDependents: "waived-benefit-for-dependents-label",
      dentalWaitingPeriod: "dental-waiting-period-label",
      basicMajorCombinedMax: "basic-major-combined-max-label",
      basicMax: "basic-max-label",
      majorMax: "major-max-label",
      routineCareReimbursement: "routine-care-reimbursement-label",
      endodonticsReimbursement: "endodontics-reimbursement-label",
      periodonticsReimbursement: "periodontics-reimbursement-label",
      bridgeWorkReimbursement: "bridge-work-reimbursement-label",
      crownsReimbursement: "crowns-reimbursement-label",
      denturesReimbursement: "dentures-reimbursement-label",
      dentureRepairReimbursement: "denture-repair-reimbursement-label",
      unitsOfScaling: "units-of-scaling-label",
      dentalRecall: "dental-recall-label",
      orthoLifetimeMax: "ortho-lifetime-max-label",
      orthodonticReimbursement: "orthodontic-reimbursement-label",
      orthodonticsTermination: "orthodontics-termination-label",
      monthsSurvivorBenefit: "months-survivor-benefit-label",
      dentalReimbursementNote: "dental-reimbursement-note-label",
      coverageFlatAmount: 'labels-coverage-flat-amount',
      basicLifeInsuranceEligibility: 'labels-basic-life-insurance-eligibility',
      coverageTimesEarnings: 'labels-coverage-times-earnings',
      benefitsPeriodWeek: 'benefits-period-week-label',
      majorMedicalInfo: 'major-medical-info-label',
      coverageReducesAtAge: 'labels-coverage-reduces-at-age',
      furtherCoverageReducesAtAge: 'labels-further-coverage-reduces-at-age',
      terminalIllnessAdvancedBenefit: 'labels-terminal-illness-advanced-benefit',
      adAndDCoverageEligibility: 'labels-ad-and-d-coverage-eligibility',
      coverageUpTo: 'labels-coverage-up-to',
      coverageTimesSalary: 'labels-coverage-times-salary',
      dependentLifeEligibility: 'dependent-life-eligibility-label',
      spouseCoverage: 'spouse-coverage-label',
      childCoverage: 'child-coverage-label',
      shortTermDisabilityCoverage: 'short-term-disability-coverage-label',
      percentageOfFlatAmountOfWeeklyEarnings: 'percentage-of-flat-amount-of-weekly-earnings-label',
      percentageFirstMaxOfMonthlyEarnings: 'percentage-first-max-of-monthly-earnings-label',
      percentageSecondMaxOfRemainder: 'percentage-second-max-of-remainder-label',
      percentageSecondMaxOfNextSecondMax: 'percentage-second-max-of-next-second-max-label',
      percentageThirdMaxOfThirdMax: 'percentage-third-max-of-third-max-label',
      ofTheNext: 'of-the-next-label',
      theRemainder: 'the-remainder-label',
      percentageFirstMaxFirstMaxWeeklyEarnings: 'percentage-first-max-first-max-weekly-earnings-label',
      elimPeriodAccident: 'elim-period-accident-label',
      elimPeriodHospital: 'elim-period-hospital-label',
      elimPeriodSickness: 'elim-period-sickness-label',
      criticalIllnessEligibility: 'critical-illness-eligibility-label',
      criticalIllnessCoverageAmount: 'critical-illness-coverage-amount-label',
      drugCoverageEligibility: 'drug-coverage-eligibility-label',
      gradedScaleExplanation: 'graded-scale-explanation-label',
      remainderSpent: 'remainder-spent-label',
      nextSecondMaxSpent: "next-$-second-max-spent-label",
      reimbursementOf: "reimbursement-label",
      soloDeductibleAmount: 'soloDeductibleAmount-label',
      duoDeductibleAmount: 'duoDeductibleAmount-label',
      familyDeductibleAmount: 'familyDeductibleAmount-label',
      claim: 'claim-label',
      preferredProviderReimbursement: "preferred-provider-reimbursement-label",
      preferredProvider: "preferred-provider-label",
      deductibleEqualToDispenseFee: "deductible-equal-to-dispense-fee-label",
      overallMaximum: "overall-maximum-label",
      substitute: "substitute-label",
      genericSubstitute: "generic-substitute-label",
      dispenseFeeMaximum: 'dispense-fee-maximum-label',
      erectileDysfunctionMaximum: 'erectile-dysfunction-maximum-label',
      erectileDysfunctionReimbursement: 'erectile-dysfunction-reimbursement-label',
      fertilityDrugsMaximum: 'fertility-drugs-maximum-label',
      fertilityDrugsReimbursement: 'fertility-drugs-reimbursement-label',
      preventativeVaccinesMaximum: 'preventative-vaccines-maximum-label',
      preventativeVaccinesReimbursement: 'preventative-vaccines-reimbursement-label',
      smokingCessationMaximum: 'smoking-cessation-maximum-label',
      smokingCessationReimbursement: 'smoking-cessation-reimbursement-label',
      paramedicalCoverage: 'paramedical-coverage-label',
      paramedCoverageMessageNotCombined: 'paramed-coverage-message-not-combined-label',
      paramedCoverageMessageCombined: 'annual-coverage-message-label',
      benefit: 'benefit-label',
      mentalWellness: "mental-wellness-label",
      paramedicalInfo: 'paramedical-info-label',
      reasonableAndCustomary: 'reasonable-and-customary-label',
      convalescentHospital: 'labels-convalescent-hospital',
      hearingAids: 'labels-hearing-aids',
      dentalAccident: 'labels-dental-accident',
      cataractSurgeryEyewear: 'labels-cataract-surgery-eyewear',
      hospitalConfinement: 'labels-hospital-confinement',
      semiPrivate: 'labels-semi-private',
      "private": 'labels-private',
      majorMedicalDisclaimer: 'labels-major-medical-disclaimer',
      visionCoverageEligibility: 'labels-vision-coverage-eligibility',
      eyeExamReimbursement: 'labels-eye-exam-reimbursement',
      eyeGlassesAndEyeWearReimbursement: 'labels-eye-glasses-and-eye-wear-reimbursement',
      safetyEyeWearReimbursement: 'labels-safety-eye-wear-reimbursement',
      employeeAssistanceProgramHumanacare: 'labels-employee-assistance-program',
      employeeAssistanceProgramDialogue: 'labels-employee-assistance-program-dialogue',
      eldercareBenefitsIncluded: 'labels-eldercare-benefits-included',
      medicalSecondOpinionBenefitsIncluded: 'labels-medical-second-opinion-benefits-included',
      dialogueEfapAccess: 'labels-dialogue-efap-access',
      mentalHealthServices: 'labels-mental-health-services',
      familyAndRelationships: 'labels-family-and-relationships',
      workAndCareer: 'labels-work-and-career',
      legalServices: 'labels-legal-services',
      financialServices: 'labels-financial-services',
      efapGuide: 'labels-efap-guide',
      learnMoreAboutEfap: 'labels-learn-more-about-efap',
      callHumanacare: 'labels-call-humanacare',
      humanacareDetails: 'labels-humanacare-details',
      virtualHealthcareDetails: 'labels-virtual-healthcare-details',
      gotodoctorCaDetails: 'labels-gotodoctor-ca-details',
      gotodoctorCa: 'labels-gotodoctor-ca-access',
      licensedCanadianPhysicians: 'labels-licensed-canadian-physicians-access',
      // Added line
      continuityOfCare: 'labels-continuity-of-care-access',
      // Added line
      dedicatedPortalAndSupport: 'labels-dedicated-portal-and-support-access',
      // Added line
      prescriptionAndProductDiscount: 'labels-prescription-and-product-discount-access',
      onSiteDiagnosticTesting: 'labels-on-site-diagnostic-testing-access',
      bookGotodoctorCaAppointment: 'labels-book-gotodoctor-ca-appointment',
      medicalDiagnosis: 'labels-medical-diagnosis-access',
      prescriptionsAndRequisitions: 'labels-prescriptions-and-requisitions-access',
      // Added line
      specialistReferrals: 'labels-specialist-referrals-access',
      // Added line
      mentalHealthSupport: 'labels-mental-health-support-access',
      // Added line
      chronicIllnessManagementAndPrevention: 'labels-chronic-illness-management-and-prevention-access',
      // Added line
      healthCoachingAndAdvice: 'labels-health-coaching-and-advice-access',
      registerAtGetmapleCaSimplybenefits: 'labels-register-at-getmaple-ca-simplybenefits',
      virtualHealthcareDialogueDetails: 'labels-virtual-healthcare-dialogue-details',
      // Added line
      unlimitedVirtualMedicalCare: 'labels-unlimited-virtual-medical-care-access',
      // Added line
      videoBasedMedicalConsultations: 'labels-video-based-medical-consultations-access',
      // Added line
      supportForWideVarietyOfIssues: 'labels-support-for-wide-variety-of-issues-access',
      // Added line
      personalizedFollowUps: 'labels-personalized-follow-ups-access',
      // Added line
      consultationsWithOtherAlliedHealthProfessionals: 'labels-consultations-with-other-allied-health-professionals-access',
      registerAtDialogueCoSignup: 'labels-register-at-dialogue-co-signup',
      outOfCountryMedicalCoverageDetails: 'labels-out-of-country-medical-coverage-details',
      // Added line
      reducesAtAgeAndTripDurationDetails: 'labels-reduces-at-age-and-trip-duration-details',
      travelAssistanceGuidelines: 'labels-travel-assistance-guidelines-access',
      // Added line
      upTo: 'labels-up-to',
      // Added line
      outOfCountryMedicalReferral: 'labels-out-of-country-medical-referral',
      // Added line
      outOfCountryReferralReimbursement: 'labels-out-of-country-referral-reimbursement',
      // Added line
      tripDuration: 'labels-trip-duration',
      // Added line
      coverageRolloverPeriod: 'labels-coverage-rollover-period',
      // Added line
      downloadAigAppOnAppleStore: 'labels-download-aig-app-on-apple-store',
      // Added line
      downloadAigAppOnGooglePlay: 'labels-download-aig-app-on-google-play',
      viewCurrentBalance: 'labels-view-current-balance',
      // Updated line
      healthSpendingAccount: 'labels-coverage-health-spending-account',
      // Updated line
      benefitExpiration: 'labels-benefit-expiration',
      // Updated line
      lifestyleSpendingClaims: 'labels-lifestyle-spending-claims',
      lifestyleSpendingAccount: 'labels-coverage-lifestyle-spending-account',
      rolloverToNextCalendarYear: 'labels-rollover-to-next-calendar-year',
      maximumRollover: 'labels-maximum-rollover',
      healthAndLifestyleIncluded: 'labels-health-and-lifestyle-included',
      reimbursementCoverageForMedicalService: 'labels-reimbursement-coverage',
      majorMedicalServicesSpendAmount: 'spend-up-to-amount-major-medical-services-label',
      combinedMaximumForMedicalService: 'labels-combined-maximum',
      days: 'days-label',
      oneDay: '1-day-label',
      maxEvidenceLabel: 'max-evidence-label',
      maxNoEvidenceLabel: 'max-no-evidence-label',
      eligibilityLabel: 'eligibility-label',
      gradedScaleFirstPart: 'graded-scale-first-part-label',
      gradedScaleSecondPart: 'graded-scale-second-part-label',
      gradedScaleThirdPart: 'graded-scale-third-part-label',
      gradedScaleFourthPart: 'graded-scale-fourth-part-label',
      flatAmountCoverage: 'flat-amount-coverage-label',
      erectileDysfunctionMedication: 'erectile-dysfunction-medication-label',
      paramedicalsReimbursement: 'paramedicals-reimbursement-label',
      upToTheBelowMaximums: 'up-to-the-below-maximums-label',
      combinedMaximumRenewal: 'combined-maximum-renewal-label',
      combinedFamilyMaximum: 'family-combined-maximum-renewal-label',
      combinedFamilyMaximumPlanOverview: 'family-combined-maximum-renewal-plan-overview-label',
      maximumRenewal: 'maximum-renewal-label',
      registerTodayAt: 'register-today-at-label',
      registrationLink: 'registration-link-label',
      bookTodayAt: 'book-today-at-label',
      bookingLink: 'booking-link-label',
      customaryExpensesForPreventativeVaccines: 'customary-expenses-for-preventative-vaccines-label',
      gradedScaleAsFollows: 'graded-scale-label',
      flatAmount: 'flat-amount-label',
      hearingAidsPerInsured: 'hearing-aids-label',
      outOfCountryMedicalReferralMax: 'out-of-country-medical-referral-max-label',
      outOfCountryMedicalReferralPerYearReimbursement: 'out-of-country-medical-referral-per-year-reimbursement-label',
      answer: 'answer-label',
      basicAndMajorCombinedMaximumUsage: 'basic-major-combined-maximum-usage-label',
      spendUpToCombinedmaxOnDentalServices: 'spend-up-to-combinedmax-dental-services-label',
      combinedMaximumCombinedmax: 'combined-maximum-combinedmax-label',
      combinedFamilyMaximumLabel: 'combined-family-maximum-label',
      spendUpToAmountOnParamedicalServices: 'spend-up-to-amount-paramedical-services-label',
      spendUpToAmountOnParamedicalServicesFamilyMaximum: 'spend-up-to-amount-paramedical-services-family-maximum-label',
      mentalWellnessLabel: 'mental-wellness-label',
      spendUpToAmountOnMentalWellnessServices: 'spend-up-to-amount-mental-wellness-services-label',
      artificialEyeLimbPerLifetime: 'artificial-eye-limb-per-lifetime-label',
      flatAmountPlanCoverage: "flat-amount-plan-coverage-label",
      timesEarnings: 'times-earnings-label',
      monthWaitingPeriod: "month-waiting-period-label",
      minimumHoursPerWeekRequired: "minimum-hours-per-week-required-label",
      maximumForSpouse: "maximum-for-spouse-label",
      maximumForChildren: 'maximum-for-children-label',
      apneaMachineAmount: "apnea-machine-amount-label",
      insulinPumpAmount: "insulin-pump-amount-label",
      unit: "coverage-unit-label",
      units: "coverage-units-label",
      lifetime: "lifetime-coverage-label",
      deductibleForSoloCoverage: "deductible-for-solo-coverage-label",
      deductibleForDuoCoverage: "deductible-for-duo-coverage-label",
      deductibleForFamilyCoverage: "deductible-for-family-coverage-label",
      gradedPercentageString: "graded-percentage-label",
      majorHealthReimbursement: 'major-health-reimbursement-label',
      majorHealthCombinedMaximum: 'major-health-combined-maximum-label',
      paramedicalReimbursement: 'paramedical-reimbursement-label',
      paramedicalCombinedMaximum: 'paramedical-combined-maximum-label',
      mentalWellnessReimbursement: "mental-wellness-reimbursement-label",
      mentalWellnessMaximum: "mental-wellness-maximum-label",
      medicalReferral: "medical-referral-reimbursment-label",
      diagnosticServices: "diagnostic-service-reimbursement-label",
      dentalAccidentMax: "dental-accident-max-label",
      dentalAccidentReimbursement: "dental-accide nt-reimbursement-label",
      hearingAidsMonths: "hearing-aids-label",
      bloodPressureMonitor: "blood-pressure-monitor-lifetime-maximum-label",
      compressionStockings: "compression-stockings-maximum-label",
      insulinPumpSupplies: "insulin-pump-supplies-maximum-label",
      artificialEyeLimbRepairReplacement: "artificial-eye-limb-repair-replacement-maximum-label",
      glucoseMonitoringEquipmentSupplies: "glucose-monitoring-equipment-supplies-maximum-label",
      tensMachine: "tens-machine-lifetime-maximum-label",
      viscosupplementation: "viscosupplementation-maximum-label",
      wheelchairManual: "wheelchair-manual-lifetime-maximum-label",
      wheelchairElectric: "wheelchair-electric-lifetime-maximum-label",
      wigs: "wigs-lifetime-maximum-label",
      cardiacRehabilitation: "cardiac-rehabilitation-maximum-label",
      footOrthotics: "foot-orthotics-maximum-label",
      orthopedicShoes: "orthopedic-shoes-maximum-label",
      privateDutyNursing: "private-duty-nursing-maximum-label",
      prosthetics: "prosthetics-lifetime-maximum-label",
      reasonableAndCustomaryExpenses: "reasonable-and-customary-label",
      ambulanceServices: "ambulance-services-label",
      hospital: "hospital-label",
      medicalEquipment: "medical-equipment-label",
      medicalServicesAndSupplies: "medical-services-and-supplies-label",
      apneaMachineSupplies: "apnea-machine-supplies-label",
      apneaMask: "apnea-mask-label",
      bracesWithRigidSupports: "braces-with-rigid-supports-label",
      crutches: "crutches-label",
      ippBreathingMachine: "ipp-breathing-machine-label",
      ostomySupplies: "ostomy-supplies-label",
      surgicalBra: "surgical-bra-label",
      employeeFamilyAssistanceProgram: "efap-label",
      medicalSecondOpinionCoverage: "medical-second-opinion-label",
      eldercareCoverage: "eldercare-coverage-label",
      eyeExamAdultMax: 'eye-exam-adult-max-label',
      eyeExamChildMax: 'eye-exam-child-max-label',
      eyeExamReimbursementMax: 'eye-exam-reimbursement-label',
      eyeGlassesAndContactsReimbursement: 'eye-glasses-contacts-reimbursement-label',
      eyeGlassesAndContactsAdultMax: 'eye-glasses-contacts-adult-max-label',
      eyeGlassesAndContactsChildMax: 'eye-glasses-contacts-child-max-label',
      requiredSafetyEyeWearReimbursement: 'required-safety-eye-wear-reimbursement-label',
      requiredSafetyEyeWearAdultMax: 'required-safety-eye-wear-adult-max-label',
      requiredSafetyEyeWearChildMax: 'required-safety-eye-wear-child-max-label',
      outOfCountryProvinceMaximum: 'out-of-country-province-maximum-Value-label',
      outOfCountryProvincePeriod30Days: 'out-of-country-province-period-30-days-label',
      outOfCountryProvincePeriod60Days: 'out-of-country-province-period-60-days-label',
      outOfCountryProvincePeriod90Days: 'out-of-country-province-period-90-days-label',
      outOfCountryProvincePeriod120Days: 'out-of-country-province-period-120-days-label',
      outOfCountryProvincePeriod180Days: 'out-of-country-province-period-180-days-label',
      tripDurationReduce: "trip-duration-reduce-label",
      healthOnly: "health-only-label",
      lifestyleOnly: "lifestyle-only-label",
      memberSetsPooledAmount: 'member-sets-pooled-amount-label',
      totalAvailableAmount: 'total-available-amount-label',
      rolloverEnabled: 'rollover-enabled-label',
      noRollover: 'no-rollover-label',
      maxHealthRollover: 'max-health-rollover-label',
      maxLifeRollover: 'max-life-rollover-label',
      healthSpendingMax: 'health-spending-max-label',
      hsaRolloverEnabled: 'hsa-rollover-enabled-label',
      noHsaRolloverEnabled: 'no-hsa-rollover-enabled-label',
      lifestyleSpendingMax: 'lifestyle-spending-max-label',
      lsaRolloverEnabled: 'lsa-rollover-enabled-label',
      noLsaRolloverEnabled: 'no-lsa-rollover-enabled-label',
      acupuncturistMaximum: 'acupuncturist-maximum-label',
      audiologistMaximum: 'audiologist-maximum-label',
      chiropractorMaximum: 'chiropractor-maximum-label',
      chiropodistMaximum: 'chiropodist-maximum-label',
      massageMaximum: 'massage-maximum-label',
      naturopathMaximum: 'naturopath-maximum-label',
      osteopathMaximum: 'osteopath-maximum-label',
      occupationalTherapistMaximum: 'occupational-therapist-maximum-label',
      physiotherapyMaximum: 'physiotherapy-maximum-label',
      podiatristMaximum: 'podiatrist-maximum-label',
      psychologistMaximum: 'psychologist-maximum-label',
      registeredDieticianMaximum: 'registered-dietician-maximum-label',
      socialWorkerMaximum: 'social-worker-maximum-label',
      speechTherapyMaximum: 'speech-therapy-maximum-label',
      paramedicalCoverageLabel: 'paramedical-coverage-label-label',
      majorMedicalCoverage: "major-medical-coverage-label",
      spouseMaximum: "spouse-maximum-label",
      routineCareReimbursementLabel: "routine-care-reimbursement-label-label",
      flex: "flex-label",
      earlyPaymentPrivilege: "early-payment-privilege-coverage-label",
      earlyPaymentPrivilegeDescription: "early-payment-privilege-description-label",
      referToBooklet: "refer-to-booklet-coverage-label",
      enrichedAcademyDescription: "enriched-academy-description-label",
      enrichedAcademyPoint1: "enriched-academy-point-1-label",
      enrichedAcademyPoint2: "enriched-academy-point-2-label",
      enrichedAcademyPoint3: "enriched-academy-point-3-label",
      enrichedAcademyPoint4: "enriched-academy-point-4-label",
      enrichedAcademyLink: "enriched-academy-link-label",
      enrichedAcademyBenefit: "enriched-academy-benefit-coverage-label",
      enrichedAcademyPrivacyStatement: "enriched-academy-privacy-statement-label",
      getStartedWithEnrichedAcademy: "get-started-with-enriched-academy-label",
      detailsOfYourEnrichedAcademyCoverage: "details-of-your-enriched-academy-coverage-label"
    },
    support: {
      getInTouchWithSupport: 'labels-get-in-touch-with-support',
      // Added line
      visitOurHelpCenter: 'labels-visit-our-help-center',
      // Added line
      subject: 'labels-subject',
      // Added line
      description: 'labels-description',
      // Added line
      send: 'labels-send',
      contactSupportMessage: 'labels-contact-support-message',
      contactSupportMessagePrivateLabel: 'labels-contact-support-message-private-label',
      chooseRelevantOrReachGeneralSupport: 'choose-relevant-or-reach-general-support-label',
      generalRequest: 'general-request-label',
      technicalSupport: 'technical-support-label',
      pendingDeniedOrCancelledClaims: 'pending-denied-cancelled-claims-label',
      changesToCoverage: 'changes-coverage-label',
      complaints: 'complaints-label',
      describeHowWeCanHelpYou: 'describe-help-label',
      visitHelpCenterOrPlaceCall: 'help-center-call-label'
    },
    spendingAccounts: {
      proratedAccount: 'labels-prorated-account',
      // Added line
      quarterlyAllowanceSet: 'labels-quarterly-allowance-set',
      // Added line
      healthSpendingAccount: 'labels-health-spending-account',
      // Added line
      lifestyleSpendingAccount: 'labels-lifestyle-spending-account',
      proratedPolicyNote: 'labels-prorated-policy-note',
      setSpendingAccountMaximums: 'labels-set-spending-account-maximums',
      // Added line
      amountAvailable: 'labels-amount-available',
      // Added line
      healthSpendingMaximum: 'labels-health-spending-maximum',
      // Added line
      lifestyleSpendingMaximum: 'labels-lifestyle-spending-maximum',
      // Added line
      proratedHealthSpendingBalance: 'labels-prorated-health-spending-balance',
      // Added line
      proratedLifestyleSpendingBalance: 'labels-prorated-lifestyle-spending-balance',
      // Added line
      setMaximums: 'labels-set-maximums',
      pooledSpendingAccountNote: 'labels-pooled-spending-account-note',
      prorationPolicyNote: 'labels-proration-policy-note',
      quarterlyAllowanceNote: 'labels-quarterly-allowance-note',
      remaining: 'labels-remaining',
      // Added line
      totalAmount: 'labels-total-amount',
      noFunds: 'labels-no-funds',
      // Added line
      lifestyleSpendingLimitReached: 'labels-lifestyle-spending-limit-reached',
      healthSpendingLimitReached: 'labels-health-spending-limit-reached',
      spent: 'labels-spent',
      ensureMaximumEqualsAvailable: 'labels-ensure-maximum-equals-available',
      whatAmEligibleFor: 'eligible-for-label',
      youAreCurrentlyIneligibleForThisBenefit: 'labels-ineligible-benefit',
      hideDetails: 'labels-hide-details',
      // Added line
      seeDetails: 'labels-see-details',
      proratedNote: 'labels-prorated-note',
      rollover: 'rollover-label',
      noHealthSpendingUsage: 'no-health-spending-usage-label',
      claimAmountMessage: "claim-amount-message-label",
      lsaCategories: "lsa-categories-label",
      claimsTemporarilyDisabled: "claims-temp-disabled-spending-accounts-label",
      claimSubmissionDisabledNote: "claim-submission-disabled-note-label"
    },
    payment: {
      covered: 'labels-covered',
      owing: 'labels-owing',
      payForServices: 'labels-pay-for-services',
      balanceOwing: 'labels-balance-owing',
      waitingForAProviderToStartASimplyPayRequest: 'labels-waiting-for-provider',
      theProviderHasCancelledThePayment: 'labels-provider-cancelled-payment',
      simplyPayRequestMessage: 'labels-simply-pay-request-message',
      topOffRemainingBalance: 'labels-top-off-remaining-balance',
      paymentConfirmed: 'labels-payment-confirmed',
      transactionReceipt: 'labels-transaction-receipt'
    },
    account: {
      accountSettingsDescription: 'labels-account-settings-description',
      changePasswordDescription: 'labels-change-password-description',
      managePaymentReimbursementDetails: 'labels-manage-payment-details',
      // Added line
      manageDependents: 'labels-manage-dependents',
      // Added line
      manageBeneficiaries: 'labels-manage-beneficiaries',
      // Added line
      manageTrustee: 'labels-manage-trustee',
      updateCreditCardOnFile: 'labels-update-credit-card-on-file',
      contactYourAdministratorToMakeChanges: 'labels-contact-administrator-changes',
      dateOfBirthYYYYMMDD: 'labels-date-of-birth',
      suiteUnit: 'labels-suite-unit',
      cityTown: 'labels-city-town',
      other: 'labels-other',
      confirmBeneficiaryChanges: 'labels-confirm-beneficiary-changes',
      datedOnYYYYMMDD: 'labels-dated-on',
      acknowledgeInfoAccuracy: 'labels-acknowledge-info-accuracy',
      noDefinedDependents: 'labels-no-defined-dependents',
      confirmDependentStudentStatus: 'labels-confirm-dependent-student-status',
      coHabDate: 'labels-co-hab-date',
      emailOptional: 'labels-email-optional',
      confirmDependentChanges: 'labels-confirm-dependent-changes',
      noTrusteeRequired: 'labels-no-trustee-required',
      addTrustee: 'labels-add-trustee',
      confirmTrusteeChanges: 'labels-confirm-trustee-changes',
      dependentsAgeLimit: 'dependents-age-limit-label',
      youHaveNoNotifications: 'no-notifications-label',
      creditCardUpdatedSuccessfully: 'credit-card-updated-label',
      modifyDetails: "modify-your-details",
      companyName: "company-name-label",
      companyContactNumber: 'company-contact-number-label',
      companyEmail: 'company-email-label',
      signingAuthorityName: 'signing-authority-name-label',
      signingAuthorityEmail: 'signing-authority-email-label',
      asoSettingsContact: 'aso-settings-contact-label',
      asoType: 'aso-type-label',
      budgeted: 'budgeted-label',
      inArrears: 'in-arrears-label',
      asoDental: 'aso-dental-label',
      asoHealth: 'aso-health-label',
      lastUpdated: "last-updated-label",
      asoDetails: "aso-details-label",
      includeOptionBenefits: "include-optionl-benefits-label",
      includeOptionBenefitsMemo: "include-optionl-benefits-memo-label",
      isMarketplaceOnly: "is-marketplace-only-label",
      includeVoluntaryBenefits: "include-voluntary-benefits",
      contactEmail: "contact-email-label",
      adminName: "admin-name-label",
      adjudicationFee: "adjudication-fee-label",
      spendingAccountMarkup: "spending-account-markup-label",
      asoHealthOrDental: "aso-health-or-dental-label",
      asoAdminFee: "admin-fee-label"
    },
    employees: {
      accountPending: "account-pending-label",
      accountPendingMessage: "account-pending-message-label",
      notifyEmployees: "notify-employees-label",
      viewEmployeeChanges: "view-employee-changes-label",
      viewPendingChanges: "view-pending-changes-label",
      salaryUpdate: "salary-update-label",
      newMember: 'new-member-label',
      noEmployees: "no-employees-label",
      filterAndSort: "filter-and-sort-label",
      "class": 'filter-class-label',
      division: 'filter-division-label',
      status: "filter-status-label",
      waivedStatus: 'filter-no-waived-status-label',
      hireDate: 'filter-hire-date-label',
      pending: 'filter-pending-label',
      active: 'filter-active-label',
      accountDisabled: 'filter-account-disabled-label',
      parentalLeave: 'filter-parental-leave-label',
      leaveOfAbsence: 'filter-leave-of-absence-label',
      temporaryLayOff: 'filter-temporary-layoff-label',
      disability: 'filter-disability-label',
      strike: 'filter-strike-label',
      lateApplicant: 'filter-late-applicant-label',
      terminated: 'filter-terminated-label',
      approvedLeave: 'filter-approved-leave-label',
      survivorBenefits: 'filter-survivor-benefits-label',
      severance: 'filter-severance-label',
      notWaived: "filter-not-waived-label",
      waived: 'filter-waived-label',
      dependentOnly: 'filter-dependent-only-label',
      extendedHealthCare: 'filter-extended-health-care-label',
      dentalAndEhc: 'filter-dental-and-ehc-label',
      memberAndDependents: 'filter-member-and-dependents',
      selectNotificationType: 'select-notification-type-label',
      selectNotificationMessage: 'select-notification-message-label',
      provideNotificationSubject: 'provide-notification-subject-label',
      provideCustomMessage: 'provide-custom-message-to-be-sent-label',
      provideMessageNotification: 'provide-notification-message-label',
      accountPendingReview: "account-pending-review-label",
      notice: 'notice-label',
      someNotificationsSentSuccessfully: 'some-notifications-sent-sucessfully-label',
      selectNotificationTypeMessage: 'select-notification-type-message-label',
      notificationType: 'notification-type-label',
      pushNotification: 'push-notification-label',
      messageType: 'message-type-label',
      enrollment: 'enrollment-label',
      marketplaceEnrollment: 'marketplace-enrollment-label',
      custom: 'custom-label',
      customSubject: 'custom-subject-label',
      customMessage: 'custom-message-label',
      performMassSalaryUpdate: "perform-mass-salary-update-label",
      selectMassSalaryFileDownload: "select-mass-salary-download-label",
      dragAndDropFilesHere: "drag-and-drop-files-here-label",
      dragAndDropImagesHere: "drag-and-drop-images-here-label",
      uploadChanges: "upload-changes-label",
      effectiveDateChange: "effective-date-change-label",
      inactive: "inactive-label",
      employee: "employee-label",
      expectedReturnDate: "expected-return-date",
      employees: "employees-label",
      journey: "journey-label",
      memberNotProvidedDependents: "member-has-not-provided-dependents-label",
      memberNotProvidedBeneficiaries: "member-has-not-provided-beneficiaries-label",
      memberNotProvidedTrustee: "member-not-provided-trustee-label",
      selectDownload: "select-download-label",
      personalInformation: "personal-information-label",
      survivorBenefit: "survivor-benefit-label",
      enrollmentDate: "enrollment-date-label",
      earningsType: "earnings-type-label",
      salary: "salary-label",
      hourlyWage: "hourly-wage-label",
      hoursPerWeek: "hours-per-week-label",
      occupation: "occupation-label",
      memberPaymentType: "member-payment-type-label",
      eft: "eft-label",
      coverageEffectiveDates: "coverage-effective-dates-label",
      memberNoChangesApplied: "member-no-changes-applied-label",
      hideAll: "hide-all-label",
      viewAll: "view-all-label",
      backdatedChanges: "backdated-changes-label",
      dateOfHireThreeMonths: "date-of-hire-three-months-label",
      individualDependents: "individual-dependents-label",
      provinceOfResidence: "province-of-residence-label",
      hourlyRate: "hourly-rate-label",
      payrollID: 'employee-payroll-id-label',
      youMustChooseToWaive: "you-must-choose-to-waive-label",
      waivingMeansThat: "waiving-means-that-label",
      waitingPeriodWaived: "waiting-period-waived-label",
      waitingPeriodNotWaived: "waiting-period-not-waived-label",
      doNotWaive: "do-not-waive-label",
      chooseToWaiveError: "choose-to-waive-error-label",
      effectiveDateOfTermination: "effective-date-of-termination-label",
      terminateEmployeeConfirmation: "terminate-employee-confirmation-label",
      iUnderstand: "i-understand-label",
      cannotAddEmployeeThatFarInPast: "cannot-add-employee-that-far-in-past-label",
      byClickingThe: "by-clicking-the-label",
      terminate: "terminate-label",
      willBeAppliedOnEffectiveDate: 'will-be-applied-on-effective-date-label',
      employeeLanguage: "employee-language-label",
      live: "employee-live-label",
      memberUpdate: "member-update-label",
      dependentUpdate: "dependent-update-label",
      beneficiaryUpdate: "beneficiary-update-label",
      massSalaryUploaded: "mass-salary-upload-label",
      coverageInformation: "coverage-information-label"
    },
    dates: {
      thisYear: 'this-year-label',
      dateStart: 'date-start-label',
      // New line
      dateEnd: 'date-end-label',
      selectDateRange: 'select-date-range-label',
      clearDates: 'clear-dates-label',
      monthAndYear: "month-and-year-label"
    },
    invoices: {
      youHaveNotBeenCharged: 'you-have-not-been-charged-label',
      division: 'division-label',
      "class": 'class-label',
      notes: 'notes-label',
      volume: 'volume-label',
      premium: 'premium-label',
      adj: 'adj-label',
      activeLives: 'active-lives-label',
      gstHst: 'gst-hst-label',
      pst: 'pst-label',
      parentInvoiceNumber: 'parent-invoice-number-label',
      invoiceNumber: 'invoice-number-label',
      taxes: 'taxes-label',
      adjustments: 'adjustments-label',
      certificate: 'certificate-label',
      viewHistory: 'view-history-label',
      optionalBenefit: 'optional-benefit-label',
      payrollID: 'payroll-id-label',
      none: 'none-label',
      noBillingHistory: 'no-billing-history-label',
      censusBilling: 'census-billing-label',
      triggerRepayment: 'trigger-repayment-label',
      premiumDueLastMonth: 'premium-due-last-month-label',
      paymentReceived: 'payment-received-label',
      carryForwardBalance: 'carry-forward-balance-label',
      currentMonthPremiumDue: 'current-month-premium-due-label',
      adjustmentsForPriorPeriod: 'adjustments-for-prior-period-label',
      asoBalanceAdjustment: 'aso-balance-adjustment-label',
      miscPremiums: 'misc-premiums-label',
      optionalBenefits: 'optional-benefits-label',
      totalPremiumForPeriod: 'total-premium-for-period-label',
      nextChargeOn10th: 'next-charge-on-10th-label',
      nextChargePhrase: "next-charge-phrase-label",
      previousMonthPremiumDue: "previous-month-premium-due-label",
      carryForward: 'carry-forward-label',
      subtotal: 'subtotal-label',
      convenienceFee: 'convenience-fee-label',
      totalDue: 'total-due-label',
      carryForwardAmountDue: 'carry-forward-amount-due-label',
      processingYourPayment: 'processing-your-payment-label',
      summaryBreakdown: 'summary-breakdown-label',
      summaryBreakdownPdf: 'summary-breakdown-pdf-label',
      finalInvoiceCalculation: 'final-invoice-calculation-label',
      totalWithdrawalDate: 'total-withdrawal-date-label',
      benefitPremiums: 'benefit-premiums-label',
      current: 'current-label',
      showDetailedAdjustments: 'show-detailed-adjustments-label',
      noAdjustmentsSinceLastBilling: 'no-adjustments-since-last-billing-label',
      changesSinceLastInvoice: 'changes-since-last-invoice-label',
      showDetailedCurrentTransactions: 'show-detailed-current-transactions-label',
      currentTransactions: 'current-transactions-label',
      currentAllocation: 'current-allocation-label',
      overview: 'overview-label',
      noMembersUnderThisDivision: 'no-members-under-this-division-label',
      registrationNumber: 'registration-number-label',
      spendingFloat: 'spending-account-float-label',
      asoFloat: 'aso-float-label',
      totalAdjustments: 'total-adjustments-label',
      rate: 'rate-label',
      benefitService: 'benefit-service-label',
      summary: 'summary-label',
      benefitPremiumSummary: 'benefit-premium-summary-label',
      invoiceNumberHeader: "invoice-number-header-label",
      groupNumberHeader: "group-number-header-label",
      dateOfPayment: "date-of-payment-label",
      marketplaceProduct: "invoice-marketplace-product-label",
      period: "invoice-period-label",
      billedTo: "billed-to-label",
      net: "net-label",
      benefit: "benefit-label",
      invoiceDownload: "invoice-Download-label",
      generateEmail: "generate-email-label",
      province: "province-csv-label",
      employeeName: "employee-csv-label",
      certNumber: "cert-csv-label",
      life: "life-csv-label",
      lifeVolume: "life-volume-csv-label",
      lifeGstHst: "life-gst-hst-csv-label",
      lifePst: "life-pst-csv-label",
      dependentLife: "dependent-life-csv-label",
      dependentLifeVolume: "dependent-life-volume-csv-label",
      dependentLifeGstHst: "dependent-life-gst-hst-csv-label",
      dependentLifePst: "dependent-life-pst-csv-label",
      add: "add-csv-label",
      addVolume: "add-volume-csv-label",
      addGstHst: "add-gst-hst-csv-label",
      addPst: "add-pst-csv-label",
      ltd: "ltd-csv-label",
      ltdVolume: "ltd-volume-csv-label",
      ltdGstHst: "ltd-gst-hst-csv-label",
      ltdPst: "ltd-pst-csv-label",
      std: "std-csv-label",
      stdVolume: "std-volume-csv-label",
      stdGstHst: "std-gst-hst-csv-label",
      stdPst: "std-pst-csv-label",
      ci: "ci-csv-label",
      ciCoverageType: "ci-coverage-type-csv-label",
      ciGstHst: "ci-gst-hst-csv-label",
      ciPst: "ci-pst-csv-label",
      ciSpouse: "ci-spouse-csv-label",
      ciSpouseCoverageType: "ci-spouse-coverage-type-csv-label",
      ciSpouseGstHst: "ci-spouse-gst-hst-csv-label",
      ciSpousePst: "ci-spouse-ps-csv-label",
      ciChild: "ci-child-csv-label",
      ciChildCoverageType: "ci-child-coverage-type-csv-label",
      ciChildGstHst: "ci-child-gst-hst-csv-label",
      ciChildPst: "ci-child-pst-csv-label",
      health: "health-csv-label",
      healthCoverageType: "health-coverage-type-csv-label",
      healthGstHst: "health-gst-hst-csv-label",
      healthPst: "health-pst-csv-label",
      ooc: "ooc-csv-label",
      oocCoverageType: "ooc-coverage-type-csv-label",
      oocGstHst: "ooc-gst-hst-csv-label",
      oocPst: "ooc-pst-csv-label",
      stopLoss: "stop-loss-csv-label",
      stopLossCoverageType: "stop-loss-coverage-type-csv-label",
      stopLossGstHst: "stop-loss-gst-hst-csv-label",
      stopLossPst: "stop-loss-pst-csv-label",
      hsa: "hsa-csv-label",
      hsaCoverageType: "hsa-coverage-type-csv-label",
      hsaGstHst: "hsa-gst-hst-csv-label",
      hsaPst: "hsa-pst-csv-label",
      lsa: "lsa-csv-label",
      lsaCoverageType: "lsa-coverage-type-csv-label",
      lsaGstHst: "lsa-gst-hst-csv-label",
      lsaPst: "lsa-pst-csv-label",
      costPlus: "cost-plus-csv-label",
      costPlusGstHst: "cost-plus-gst-hst-csv-label",
      costPlusPst: "cost-plus-pst-csv-label",
      virtualHealthcare: "virtual-healthcare-csv-label",
      virtualHealthcareCoverageType: "virtual-healthcare-coverage-type-csv-label",
      virtualHealthcareGstHst: "virtual-healthcare-gst-hst-csv-label",
      virtualHealthcarePst: "virtual-healthcare-pst-csv-label",
      efap: "efap-csv-label",
      efapCoverageType: "efap-coverage-type-csv-label",
      efapGstHst: "efap-gst-hst-csv-label",
      efapPst: "efap-pst-csv-label",
      dental: "dental-csv-label",
      dentalCoverageType: "dental-coverage-type-csv-label",
      dentalGstHst: "dental-gst-hst-csv-label",
      dentalPst: "dental-pst-csv-label",
      hboMisc: "hbo-misc-csv-label",
      myCareAdvantageMisc: "mycare-advantage-misc-csv-label",
      hboChildMisc: "hbo-child-misc-csv-label",
      myCareAdvantageChildMisc: "mycare-advantage-child-misc-csv-label",
      miscTotal: "misc-total-csv-label",
      totalWithTax: "total-with-tax-csv-label",
      adjustmentDescription: "adjustment-description-csv-label",
      specialityProducts: 'speciality-products'
    },
    signup: {
      createAccount: 'create-account-label',
      planSelection: 'plan-selection-label',
      confirmPassword: 'confirm-password-label',
      pleaseConfirmThatYourPasswordsMatch: 'confirm-password-match-label',
      enrolmentExperienceBestOnDesktopComputer: 'desktop-computer-enrolment-experience-label',
      ensureCompletedEntireForm: 'form-completion-instructions-label',
      createPasswordSecurityInstructions: 'create-password-security-label',
      createAPasswordThatContains: 'create-password-label',
      numbers: 'numbers-label',
      letters: 'letters-label',
      and: 'and-label',
      specialCharacters: 'special-characters-label',
      toMaximizeSecurity: 'maximize-security-label',
      coverageSelectionInstructions: 'select-coverage-instructions-label',
      coverageSelectionDetails: 'select-coverage-details-label',
      justYou: 'just-you-label',
      youAndPartnerOrChild: 'you-partner-child-label',
      twoOrMoreDependents: 'two-or-more-dependents-label',
      commonLawDefinition: 'common-law-definition-label',
      commonLawLiving: 'common-law-living-label',
      livingWithYou: 'living-with-you-label',
      solo: 'solo-label',
      duo: 'duo-label',
      family: 'family-label',
      definitionCommonLaw: 'common-law-definition-label',
      itsYou: 'its-you-label',
      parentByBirthOrAdoption: 'parent-by-birth-or-adoption-label',
      custodyOrControl: 'custody-control-label',
      youOrDependents: 'you-or-dependents-label',
      enrolledInAnotherHealthPlan: 'enrolled-in-another-plan-label',
      youCan: 'you-can-label',
      waive: 'waive-label',
      Waive: 'Waive-label',
      yourExtendedHealthCare: 'your-extended-health-care-label',
      coordinateYourHealthPlan: 'coordinate-plan-label',
      withYourDependentsToMaximizeCoverage: 'maximize-coverage-label',
      coverageDeclineInstructions: 'coverage-decline-instructions-label',
      refuse: 'refuse-label',
      doNotRefuse: 'do-not-refuse-label',
      iAmRefusingForTheFollowingBenefits: 'i-am-refusing-for-the-following-benefits-label',
      extendedHealthCare: 'extended-health-care-label',
      both: 'both-label',
      extendedHealthAndDentalCoverage: 'extended-health-and-dental-coverage-label',
      waiveCoverageFor: 'waive-coverage-for-label',
      myselfAndDependents: 'myself-and-dependents-label',
      dependentsOnly: 'dependents-only-label',
      forTheFollowingBenefits: 'for-the-following-benefits-label',
      selectOptionForEachSection: 'select-option-for-each-section-label',
      selectOptionBeforeContinuing: 'select-option-before-continuing-label',
      expectingNameError: 'expecting-firstname-error-label',
      waivingCoverageForYourselfAndYourDependents: 'waiving-coverage-for-yourself-and-your-dependents-label',
      waivingCoverageForYourDependents: 'waiving-coverage-for-your-dependents-label',
      mustSubmitEvidenceOfInsurability: 'must-submit-evidence-of-insurability-label',
      provideComparableCoverageEmployer: 'provide-comparable-coverage-employer-label',
      provideComparableCoverageInsuranceCarrier: 'provide-comparable-coverage-insurance-carrier-label',
      provideComparableCoverageCertificationNumber: 'provide-comparable-coverage-certification-number-label',
      employer: 'employer-label',
      insuranceCarrier: 'insurance-carrier-label',
      certificateNumber: 'certificate-number-label',
      understandLiabilityForDepLifeClaims: 'understand-liability-for-dep-life-claims-label',
      byRefusingCoverageUnderstandPlan: 'by-refusing-coverage-understand-plan-label',
      dependentLifeExtendedHealthCareAndDental: 'dependent-life-extended-health-care-and-dental-label',
      dependentLifeAndExtendedHealthCare: 'dependent-life-and-extended-health-care-label',
      dependentLifeAndDental: 'dependent-life-and-dental-label',
      addingDependentsToHealthPlan: 'adding-dependents-to-health-plan-label',
      validDependentsInclude: 'valid-dependents-include-label',
      spouse: 'spouse-label',
      commonLawPartners: 'common-law-partners-label',
      includingSeparated: 'including-separated-label',
      livingTogetherInConjugalRelationshipForMinimumOf1Year: 'living-together-in-conjugal-relationship-label',
      children: 'children-label',
      adoptedOrNatural: 'adopted-or-natural-under-age-of-21-or-under-age-of-25-if-full-time-students-label',
      howManyDependentsDoYouHave: 'how-many-dependents-do-you-have-label',
      acknowledgeFullyUnderstandAboveConditions: 'acknowledge-fully-understand-above-conditions-label',
      optionallyProvideAnEmailAddressForYourDependent: 'optionally-provide-email-for-dependent-label',
      theirOwnLogin: 'their-own-login-label',
      viewCoverageSubmitClaimsAndMore: 'view-coverage-submit-claims-and-more-label',
      coHabDateYyyyMmDd: 'co-hab-date-yyyy-mm-dd-label',
      spouseCommonLawPartnerAdditionalGroupBenefitsDetails: 'spouse-common-law-partner-additional-group-benefits-details-label',
      spousesEmployerLabel: 'spouse-employer-label',
      spousesCurrentInsuranceCarrier: 'spouse-current-insurance-carrier-label',
      addAnotherDependentToHealthPlan: 'add-another-dependent-to-health-plan-label',
      button: 'button-label',
      dependent: 'dependent-label',
      confirmDependentStatus: 'confirm-dependent-status-label',
      continueWithNoDependents: 'continue-with-no-dependents-label',
      belowDependentsNotYetEligibleForBenefits: 'below-dependents-not-yet-eligible-for-benefits-label',
      howManyBeneficiariesDoYouHave: 'how-many-beneficiaries-do-you-have-label',
      proceedsIfNoPrimaryBeneficiariesAlive: 'proceeds-if-no-primary-beneficiaries-alive-label',
      addContingentBeneficiariesOptional: 'add-contingent-beneficiaries-optional-label',
      a: 'a-label',
      contingentBeneficiary: 'contingent-beneficiary-label',
      beneficiary: 'beneficiary-label',
      individualAssignedToReceiveInsuranceAmountsInEvent: 'individual-assigned-to-receive-insurance-amounts-label',
      ofYourDeath: 'of-your-death-label',
      isThePersonsSpouseParentChildThatWill: 'is-the-persons-spouse-parent-child-that-will-label',
      your: 'your-label',
      receive: 'receive-label',
      allOfYourGroup: 'all-of-your-group-label',
      lifeInsuranceBenefits: 'life-insurance-benefits-label',
      includingCriticalIllnessPayable: 'including-critical-illness-payable-label',
      atYourDeath: 'at-your-death-label',
      shareMustEqual100: 'share-must-equal-100-label',
      moreThanOneBeneficiary: 'more-than-one-beneficiary-label',
      revocableBeneficiary: 'revocable-beneficiary-label',
      canBeChangedByYouAtAnyTime: 'changeable-beneficiary-label',
      andYou: 'and-you-label',
      irrevocableBeneficiaryCannotBeChanged: 'irrevocable-beneficiary-label',
      certainChangesWithoutWrittenConsent: 'changes-without-consent-label',
      shares: 'shares-label',
      youCanOnlyHave1Spouse: 'one-spouse-limit-label',
      personWhoWillManageBenefitsForMinors: 'benefits-manager-for-minors-label',
      closeFriend: 'close-friend-label',
      parent: 'parent-label',
      ifNoneAreLivingIndicateAResponsible: 'indicate-responsible-if-none-living-label',
      familyMember: 'family-member-label',
      beneficiaryDesignations: 'beneficiary-designations-label',
      finishedFillingOutEnrolmentForm: 'finished-enrolment-form-label',
      readyToSubmitYourDetails: 'ready-to-submit-details-label',
      provideNameESignatureDateAndClick: 'provide-name-esig-date-click-label',
      completeYourEnrolmentButton: 'complete-enrolment-button-label',
      accountCreatedSuccessfully: 'account-created-successfully-label',
      thisSectionIsFor: 'section-for-label',
      settingTheMaximums: 'setting-maximums-label',
      ofYourPooledSpendingAccounts: 'pooled-spending-accounts-label',
      divideTotalAmountsBetweenHSAAndLSA: 'divide-amounts-hsa-lsa-label',
      thisCannotBeChangedLater: 'cannot-change-later-label',
      yourHealthSpendingAccountHSAIsA: 'HSA-description-label',
      benefitItsUsedTo: 'HSA-benefit-description-label',
      topOffServiceLessThan100: 'top-off-service-label',
      coverCostsNotCoveredOnYourPlan: 'cover-costs-not-covered-label',
      payForServicesThatHitMaximums: 'pay-for-services-maximums-label',
      yourLifestyleSpendingAccountLSAIsA: 'lsa-description-label',
      benefitAndWillCountAs: 'benefit-count-as-label',
      incomeEarned: 'income-earned-label',
      duringTaxSeason: 'during-tax-season-label',
      youCanUseThisBenefitTo: 'use-benefit-label',
      buyHealthGoodsAndServices: 'buy-health-goods-services-label',
      specifiedByEmployerNotIncludedInHealthPlan: 'employer-specified-excluded-label',
      soloCoverageTypeMessage: 'solo-coverage-type-message-label',
      language: "language-signup-label",
      youHaveBeenGivenAModFlexAccount: "you-have-been-given-a-modflex-account-label",
      drug: "drug-signup-label",
      gradedPercentageString: "graded-percentage-string-label",
      rcExpensesForPreventativeVaccines: "rc-expenses-for-preventatve-vaccines-label",
      majorHealthReimbursement: 'major-health-reimbursement-label',
      majorHealthCombinedMaximum: 'major-health-combined-maximum-label',
      paramedicalReimbursement: 'paramedical-reimbursement-label',
      paramedicalCombinedMaximum: 'paramedical-combined-maximum-label',
      acupuncturistMaximum: 'acupuncturist-maximum-label',
      audiologistMaximum: 'audiologist-maximum-label',
      chiropractorMaximum: 'chiropractor-maximum-label',
      chiropodistMaximum: 'chiropodist-maximum-label',
      massageMaximum: 'massage-maximum-label',
      naturopathMaximum: 'naturopath-maximum-label',
      osteopathMaximum: 'osteopath-maximum-label',
      occupationalTherapistMaximum: 'occupational-therapist-maximum-label',
      physiotherapyMaximum: 'physiotherapy-maximum-label',
      podiatristMaximum: 'podiatrist-maximum-label',
      psychologistMaximum: 'psychologist-maximum-label',
      registeredDieticianMaximum: 'registered-dietician-maximum-label',
      socialWorkerMaximum: 'social-worker-maximum-label',
      speechTherapyMaximum: 'speech-therapy-maximum-label',
      hearingAids: 'signup-hearing-aids-label',
      dentalAccidentMaximum: 'dental-accident-maximum-label',
      cardiacRehabilitationMaximum: 'cardiac-rehabilitation-maximum-label',
      footOrthoticsMaximum: 'foot-orthotics-maximum-label',
      orthopedicShoesMaximum: 'orthopedic-shoes-maximum-label',
      privateDutyNursingMaximum: 'private-duty-nursing-maximum-label',
      prostheticsLifetimeMaximum: 'prosthetics-lifetime-maximum-label',
      artificialEyeLimbsRepairReplacementMaximum: 'artificial-eye-limbs-repair-replacement-maximum-label',
      bloodPressureMonitorLifetimeMaximum: 'blood-pressure-monitor-lifetime-maximum-label',
      compressionStockingsMaximum: 'compression-stockings-maximum-label',
      glucoseMonitoringEquipmentSuppliesMaximum: 'glucose-monitoring-equipment-supplies-maximum-label',
      insulinPumpSuppliesMaximum: 'insulin-pump-supplies-maximum-label',
      tensMachineLifetimeMaximum: 'tens-machine-lifetime-maximum-label',
      viscosupplementationMaximum: 'viscosupplementation-maximum-label',
      wheelchairManualLifetimeMaximum: 'wheelchair-manual-lifetime-maximum-label',
      wheelchairElectricLifetimeMaximum: 'wheelchair-electric-lifetime-maximum-label',
      wigsLifetimeMaximum: 'wigs-lifetime-maximum-label',
      employeeFamilyAssistanceProgram: 'employee-family-assistance-program-label',
      outOfCountryProvinceMaximum: 'out-of-country-province-maximum-label',
      outOfCountryProvincePeriod30Days: 'out-of-country-province-period-30-days-label',
      outOfCountryProvincePeriod60Days: 'out-of-country-province-period-60-days-label',
      outOfCountryProvincePeriod90Days: 'out-of-country-province-period-90-days-label',
      outOfCountryProvincePeriod120Days: 'out-of-country-province-period-120-days-label',
      outOfCountryProvincePeriod180Days: 'out-of-country-province-period-180-days-label',
      reasonableAndCustomaryExpenses: 'reasonable-and-customary-expenses-label',
      hospital: 'signup-hospital-label',
      medicalSecondOpinionCoverage: 'medical-second-opinion-coverage-label',
      eldercareCoverage: 'eldercare-coverage-label',
      eyeExamAdultMax: 'eye-exam-adult-max-label',
      eyeExamChildMax: 'eye-exam-child-max-label',
      eyeExamReimbursement: 'eye-exam-reimbursement-label',
      eyeGlassesAndContactsReimbursement: 'eye-glasses-contacts-reimbursement-label',
      eyeGlassesAndContactsAdultMax: 'eye-glasses-contacts-adult-max-label',
      eyeGlassesAndContactsChildMax: 'eye-glasses-contacts-child-max-label',
      requiredSafetyEyeWearReimbursement: 'required-safety-eye-wear-reimbursement-label',
      requiredSafetyEyeWearAdultMax: 'required-safety-eye-wear-adult-max-label',
      requiredSafetyEyeWearChildMax: 'required-safety-eye-wear-child-max-label',
      basicDental: 'basic-dental-label',
      majorDental: 'major-dental-label',
      youMustSelectHealthAndDental: "you-must-select-health-and-dental-label",
      spendingAccountCombinedMaximum: "spending-account-combined-maximum",
      spendingAccountHsaMaximum: "spending-account-hsa-maximum",
      spendingAccountLsaMaximum: "spending-account-lsa-maximum"
    },
    lsaModal: {
      seeBelowTaxableLSACategoriesCovered: 'taxable-lsa-categories-covered-label',
      alternativePractitioner: 'alternative-practitioner-label',
      cosmetic: 'cosmetic-label',
      fitnessAndSports: 'fitness-sports-label',
      personal: 'personal-label'
    },
    notifications: {
      spendingAccountMaximumsSetSuccessfully: 'spending-account-maximums-set-successfully-label',
      youHaveNewNotifications: 'new-notifications-label',
      checkInboxForPasswordRecoveryEmail: 'password-recovery-email-check-label',
      checkEmailInboxForSupportResponse: 'email-inbox-support-response-label',
      dependentAddedSuccessfully: 'dependent-added-successfully-label',
      successfullyUpdatedUserSettings: 'user-settings-updated-successfully-label',
      successfullySavedBankingDetails: 'banking-details-saved-successfully-label',
      passwordChangedSuccessfully: 'password-changed-successfully-label',
      dependentUpdatedSuccessfully: 'dependent-updated-successfully-label',
      dependentRemovedSuccessfully: 'dependent-removed-successfully-label',
      beneficiaryAddedSuccessfully: 'beneficiary-added-successfully-label',
      beneficiaryUpdatedSuccessfully: 'beneficiary-updated-successfully-label',
      beneficiaryRemovedSuccessfully: 'beneficiary-removed-successfully-label',
      trusteeAddedSuccessfully: 'trustee-added-successfully-label',
      trusteeUpdatedSuccessfully: 'trustee-updated-successfully-label',
      trusteeRemovedSuccessfully: 'trustee-removed-successfully-label',
      somethingWentWrong: 'something-went-wrong-label',
      claimsSummaryReportSentSuccessfully: 'claims-summary-report-sent-successly-label',
      somethingWentWrongMessage: "something-went-wrong-message-label",
      simplyBenefitsIsBestUsed: "simply-benefits-is-best-used-label",
      yourSessionHasExpired: "your-session-has-expired-label",
      youDoNotBelongToThisOrganization: "you-do-not-belong-to-this-organization-label",
      accountUpdatedSuccessfully: "account-updated-successfully-label",
      adminCreatedSuccessfully: "admin-created-successfully-label",
      adminRemovedSuccessfully: "admin-removed-successfully-label",
      adminUpdatedSuccessfully: "admin-updated-successfully-label",
      updatedAdminSettings: "updated-admin-settings-label",
      notificationsSentSuccessfully: "notifications-sent-successfully-label",
      savedPaymentDetails: "saved-payment-details-label",
      usersAddedSuccessfully: "users-added-successfully-label",
      updatedAdvisorSettings: "updated-advisor-settings-label",
      successfullyUpdatedAccount: "successfully-updated-account-label",
      masterAppSetBack: "master-app-set-back-label",
      accountLive: "account-live-label",
      requestForUnderwriting: "request-for-underwriting-label",
      masterApplicationSavedSuccessfully: "master-application-saved-successfully",
      masterApplicationSubmittedSuccessfully: "master-application-submitted-successfully",
      planAssignedFinished: "plan-assignment-finished-label",
      pricingRejectedSuccessfully: "pricing-rejected-successfully-label",
      commissionsSavedSuccessfully: "commissions-saved-successfully-label",
      amendmentApproved: "amendment-approved-successfully-label",
      accountHistorySubmittedSuccessfully: "account-history-submitted-successfully-label",
      employeeAddedSuccessfully: "employee-added-successfully-label",
      employeeUpdatedSuccessfully: "employee-updated-successfully-label",
      userTerminatedSuccessfully: "user-terminated-succesfully-label",
      classAddedSuccessfully: "class-added-successfully-label",
      classSavedSuccessfully: "class-saved-successfully-label",
      divisionAddedSuccessfully: "division-added-successfully-label",
      divisionSavedSuccessfully: "division-saved-successfully-label",
      planDesignSaved: "plan-designed-saved-label",
      modularFlexBlueprint: 'modular-flex-blueprint-label',
      quoteCreatedSuccessfully: "quote-created-successfully-label",
      quoteEditedSuccessfully: "quote-edited-successfully-label",
      classRemovedSuccessfully: "class-removed-successfully-label",
      divisionRemovedSuccessfully: "division-removed-successfully-label",
      productDeclined: "product-declined-notification-label",
      successfullyUpdatedPassword: "successfully-updated-password-label",
      latestAppVersion: "latest-app-version-label",
      claimSummarySuccessfullyEmailed: "claim-summary-successfully-emailed-label",
      purchaseCompletedSuccessfully: "purchase-completed-successfully-label",
      productTerminatedSuccessfully: "product-terminated-successfully-label"
    },
    infoModal: {
      binCarrierId: "bin-carrier-id-label",
      carrierName: "carrier-name-label",
      carrierNumber: "carrier-number-label",
      cdanetMessageVersion: "cdanet-message-version-label",
      cdanetTransactions: "cdanet-transactions-label",
      supportedCdanetTransactions: "supported-cdanet-transactions-label",
      coverageTypeSelection: "coverage-type-selection-label",
      dentalOfficeInformationNeeded: "dental-office-information-needed-label",
      dentistDenturistHygienist: "dentist-denturist-hygienist-label",
      goingToDentistLabel: "going-to-dentist-label",
      goingToPharmacyLabel: "going-to-pharmacy-label",
      groupNumber: "info-modal-group-number-label",
      importantNote: "important-note-label",
      locatedOnBenefitsCard: "located-on-benefits-card-label",
      network: "network-label",
      pharmacistHavingTrouble: "pharmacist-having-trouble-label",
      pharmacistInformationNeeded: "pharmacist-information-needed-label",
      pharmacistTroubleEnteringDetails: "pharmacist-trouble-entering-details-label",
      pharmacyHelpCenter: "pharmacy-help-center-label",
      supportedProviderType: "supported-provider-type-label"
    },
    admin: {
      adminEmail: 'admin-email-label',
      plan: 'plan-label',
      employees: 'employees-label',
      reports: 'reports-label',
      administrators: 'administrators-label',
      settings: 'settings-label',
      viewPlanCoverage: 'view-plan-coverage-label',
      viewManageEmployees: 'view-manage-employees-label',
      generateExportReports: 'generate-export-reports-label',
      viewCurrentAndHistoryInvoice: 'view-current-history-label',
      viewManageAccountAdministrators: 'view-manage-account-administrators-label',
      viewManageAccountSettings: 'view-manage-account-settings-label',
      adminPersonalizedDashboard: 'welcome-to-personalized-dashboard-admin-label',
      asoReporting: "aso-reporting-label",
      planCoverage: "plan-coverage-label",
      dateRangeStartEnd: "date-range-start-end-label",
      showingChangesFrom: "showing-changes-from-label",
      user: "user-label",
      field: "field-label",
      oldValue: "old-value-label",
      newValue: "new-value-label",
      changedBy: "changed-by-label",
      dateOfChange: "date-of-change-label",
      effectiveDate: "effective-date-label",
      noRecords: "no-records-label",
      allPendingChanges: "showing-pending-changes-label",
      scheduledChangeWillNotTakePlace: 'scheduled-change-will-not-take-place-label',
      label: "label-label",
      profileCertificate: "profile-certificate-label",
      processed: "processed-label",
      createAdmin: "create-admin-label",
      addAdminToAccount: "add-admin-to-account-label",
      planSponsor: "plan-sponsor-label",
      parentAdmin: "parent-admin-label",
      person: "person-label",
      removeAdmin: "remove-admin-label",
      removeAdminConfirmation: "remove-admin-confirmation-label",
      editAdmin: "edit-admin-label",
      adminFirstName: "admin-first-name-label",
      adminLastName: "admin-last-name-label",
      adminPermissions: "admin-permissions-label",
      giveThisAdmin: "give-this-admin-label",
      parentAdminsFullAccess: "parent-admins-full-access-label",
      forEachDivision: "for-each-division-label",
      theAdmin: "the-admin-label",
      adminWillNotBeAbleToView: "admin-will-not-be-able-to-view-label",
      adminCanOnlyView: "admin-can-only-view-label",
      adminCanViewAndManage: "admin-can-only-manage-label",
      noneSelected: "none-selected-label",
      readOnly: "read-only-label",
      readAndWrite: "read-and-write-label",
      divisions: "divisions-label",
      planOverview: "plan-overview-label",
      classAndDivisionDetails: "class-and-division-details-label",
      viewHistory: "view-history-label",
      downloadAccountSummary: "download-account-summary-label",
      noAsoHistory: "no-aso-history-label",
      accountHasNoASOHistory: "account-has-no-aso-history-label"
    },
    advisor: {
      advisorEmail: 'advisor-email-label',
      continueQuotingProcess: "continue-quoting-process-label",
      soldAccounts: 'sold-accounts-label',
      viewManageActiveAccounts: 'view-manage-active-accounts-label',
      viewLostAccounts: 'view-lost-accounts-label',
      viewAmendedAccounts: 'view-amended-accounts-label',
      viewCommissions: 'view-commissions-label',
      healthDashboardWelcome: 'health-dashboard-welcome-label',
      viewTheAccountPlanDetails: "view-account-plan-details-label",
      completeSubmitMasterApplication: 'complete-submit-master-application-label',
      viewManageAccountAdmins: 'view-manage-account-admins-label',
      setAccountActiveStartBenefitsPlan: 'set-account-active-start-benefits-plan-label',
      inputManageEmployeeInformation: 'input-manage-employee-information-label',
      viewSetCommissionsForAccount: 'view-set-commissions-for-account-label',
      viewPlanPricing: 'view-plan-pricing-label',
      generateExportReportsAnalytics: 'generate-export-reports-analytics-label',
      viewAccountInvoices: 'view-account-invoices-label',
      viewHistoryOfGroupAmendments: 'view-history-of-group-amendments-label',
      reviewClassBooklets: 'review-class-booklets-label',
      viewCoveredLSACategories: 'view-covered-lsa-categories-label',
      noActiveAccounts: "no-active-accounts-label",
      youHaveNotFinalizedAccounts: "you-have-not-finalized-accounts-label",
      updated: "updated-accounts-label",
      viewCommissionsInstructions: "view-commissions-instructions-label",
      commissionsChangeNotice: "commissions-change-notice-label",
      setCommissionRatesInstructions: "set-commission-rates-instructions-label",
      finalizeCommissionRatesInstructions: "finalize-commission-rates-instructions-label",
      setAll: "set-all-label",
      setIndividually: "set-individually-label",
      successfulSubmissionMessage: "successful-submission-message-label",
      commissionsCanOnlyBeBackdated: "commissions-can-only-be-back-dated-label",
      rateSummary: "rate-summary-label",
      previousRates: "previous-rates-label",
      rate: "advisor-rate-label",
      solo: "advisor-solo-label",
      duo: "advisor-duo-label",
      family: "advisor-family-label",
      manageClassesAndDivisions: "advisor-manage-classes-and-divisions-label",
      provideDocuments: 'provide-documents-label',
      viewCustomizePlanDesigns: 'view-customize-plan-designs-label',
      completeSubmitPlanDesigns: 'complete-submit-plan-designs-label',
      completeSubmitCommissions: 'complete-submit-commissions-label',
      setPricingForPlanDesigns: 'set-pricing-for-plan-designs-label',
      submitAccountUnderwritingPricing: 'submit-account-underwriting-pricing-label',
      alreadySentQuoteUnderwriting: 'already-sent-quote-underwriting-label',
      pleaseCompleteSubmitMasterApplication: 'complete-submit-master-application-label',
      assignFinalPlanDesigns: 'assign-final-plan-designs-label',
      assignPlansNote: 'assign-plans-note-label',
      alreadyAssignedPlanDesigns: 'already-assigned-plan-designs-label',
      reviewSendQuote: 'review-send-quote-label',
      completeSubmitAssignPlans: 'complete-submit-assign-plans-label',
      alreadySubmittedQuoteApproval: 'already-submitted-quote-approval-label',
      pendingCommissions: 'pending-commissions-label',
      paidCommissions: "paid-commissions-label",
      filters: "filters-label",
      accounts: "accounts-commission-label",
      status: "status-commission-label",
      noCommissionRecords: "no-commission-records-label",
      account: "account-commission-label",
      amount: "amount-commission-label",
      paidDate: "paid-date-commission-label",
      dateAdded: "date-added-commission-label",
      noPendingAccounts: "no-pending-accounts-label",
      youDoNotHavePendingAccounts: "you-do-not-have-pending-accounts-label",
      lostOpportunities: "lost-opportunity-label",
      noLostOpportunities: "no-lost-opportunity-label",
      noLostOpportunitiesText: "no-lost-opportunity-text-label",
      accountsUnderAmendment: "accounts-under-amendment-label",
      noAccountsUnderAmendment: "no-accounts-under-amendment-label",
      noAccountsUnderAmendmentText: "no-accounts-under-amendment-text-label",
      bookletDownloading: "class-booklet-downloadng-label",
      classBookletDownloading: "class-booklet-downloading-message-label",
      noActiveBooklet: 'no-active-class-booklet-label',
      booklet: "booklet-label",
      groupAmendments: "group-amendments-label",
      viewAllGroupAmendments: "view-all-group-amendments-label"
    },
    reports: {
      report: "report-label",
      membersAndUsage: "member-and-usage-label",
      overAgeMemberListing: "over-age-member-listing-report-label",
      overAgeMemberAnniversary: "overage-member-listing-label",
      viewAllMembersWhoWillBecomeOlder: "view-all-members-who-will-become-older-label",
      overAgeDependentListing: "overage-dependent-listing-label",
      overageDependent: "overage-dependent-label",
      viewAllCurrentDependentsOverage: "view-all-current-dependents-overage-label",
      dependentListing: "dependent-listing-label",
      viewAllCurrentDependents: "view-all-current-dependents-label",
      spendingAccountUsages: "spending-account-usages-label",
      hsaLsaUsages: "hsa-lsa-usages-label",
      viewSpendingAccountPremiums: "view-spending-account-premiums-label",
      hsaBalance: "hsa-balance-label",
      viewCurrentHsaBalancesPerMember: "view-current-hsa-balances-per-member-label",
      lsaBalance: "lsa-balance-label",
      viewCurrentLsaBalancesPerMember: "view-current-lsa-balances-per-member-label",
      certificateListing: "certificate-listing-label",
      getDataOnEachMember: "get-data-on-each-member-label",
      nemEligibilityReportDesc: "nem-eligibility-report-desc",
      nemEligibilityReportTitle: "nem-eligibility-report-title",
      financial: "financial-label",
      asoMonthlySummary: "aso-monthly-summary-label",
      viewAsoMonthlySummary: "view-aso-monthly-summary-label",
      taxableBenefit: "taxable-benefit-label",
      viewYearlyPremium: "view-yearly-premium-for-each-taxable-label",
      ltdReport: "ltd-report-label",
      ltd: "ltd-label",
      viewLtdDisabilityReport: "view-ltd-disability-report-label",
      age: "age-label",
      allDivisions: "all-divisions-label",
      allClasses: 'all-classes-label',
      all: "all-label",
      noRecords: "no-records-report-label",
      to: "to-label",
      from: "from-label",
      yes: 'yes-label',
      no: 'no-label',
      none: 'none-label',
      single: 'single-label',
      couple: 'couple-label',
      family: 'family-label',
      waived: 'waived-label',
      datePrepared: "date-prepared-label",
      ltdReportHeader: "ltd-header-label",
      group: "group-label",
      payrollID: "payrool-id-label",
      volume: 'volume-label',
      approvedVolume: 'approved-volume-label',
      premium: 'premium-label',
      salary: 'salary-label',
      lossRatioReport: "loss-ratio-report-label",
      healthcareInformation: "healthcare-info-label",
      totalPremium: "total-premium-label",
      totalClaimsPaid: "total-claims-label",
      lossRatio: "loss-ratiro-label",
      viewLossRatio: "view-loss-ratio-label",
      dentalInformation: "dental-info-label",
      major: "major-label",
      basic: "basic-label",
      orthodontics: "orthodontics-label",
      claims: "claims-label",
      amount: "amount-label",
      forThePeriod: "for-the-period-label"
    },
    masterApplication: {
      reviewAndSignApplication: "review-and-sign-application-label",
      reviewMasterApplication: "review-master-application-label",
      sendForApproval: "send-for-approval-label",
      completeAndSubmit: "complete-and-submit-label",
      reviewFinalizedMasterApplication: "review-finalized-master-application-label",
      completeTheMasterApplication: "complete-the-master-application-label",
      groupApplicantsData: "group-applicants-data-label",
      totalLivesToBeInsured: "total-lives-to-be-insured-label",
      companyAddress: "company-address-label",
      natureOfBusiness: "nature-of-business-label",
      corporation: "corporation-label",
      partnership: "partnership-label",
      soleProprietorship: "sole-proprietorship-label",
      unionized: "unionized-label",
      jointVenture: "joint-venture-label",
      applicantHasExistingGroupBenefits: "applicant-has-existing-group-benefits-label",
      employeesCurrentlyInsured: "employees-currently-insured-label",
      employeesCoveredByWCBWSIB: "employees-covered-by-wcb-wsib-label",
      businessIs: "business-is-label",
      existingCarrier: "existing-carrier-label",
      none: "none-master-application-label",
      dependentsWithSurvivorBenefits: "dependents-with-survivor-benefits-label",
      employeesNotAtWork: "employees-not-at-work-label",
      contractEmployees: "contract-employees-label",
      excludedFromGroupBenefits: "excluded-from-group-benefits-label",
      stopLoss: "stop-loss-label",
      applicantHasStopLoss: "applicant-has-stop-loss-label",
      stopLossLevel: "stop-loss-level-label",
      recurringEHCClaims: "recurring-ehc-claims-label",
      lifestyleSpendingAccount: "lifestyle-spending-account-label",
      selectedLifestyleItems: "selected-lifestyle-items-label",
      notes: "notes-label",
      existingGroupBenefits: "existing-group-benefits-label",
      advisorSignature: "advisor-signature-label",
      advisorName: "advisor-name-label",
      advisorDatedOn: "advisor-dated-on-label",
      authoritySignature: "authority-signature-label",
      authorityDatedOn: "authority-dated-on-label",
      advisorAcknowledgment: "advisor-acknowledgment-label",
      witnessSignature: "witness-signature-label",
      witnessName: "witness-name-label",
      witnessDatedOn: "witness-dated-on-label",
      witnessAcknowledgment: "witness-acknowledgment-label",
      authorityAcknowledgment: "authority-acknowledgment-label",
      authorityName: "authority-name-label",
      dependentName: "dependent-name-label",
      expiryDate: "expiry-date-label",
      employeeName: "employee-name-label",
      dateLastWorked: "date-last-worked-label",
      reason: "reason-label",
      occupation: "occupation-label",
      employeeNameCategory: "employee-name-category-label",
      nameOfInsurerCarrier: "name-of-insurer-carrier-label",
      submissionSuccess: "submission-success-label",
      name: "name-label",
      companyName: "company-name-label",
      benefitsCovered: "benefit-covered-label",
      notApplicable: "not-appilcable-label",
      yes: "yes-label",
      no: "no-label",
      expectedReturnDate: "expected-return-label",
      claimStatus: "claim-status-label",
      lsaItems: "lsa-item-label",
      contractStartDate: "contract-start-label",
      contractEndDate: "contract-end-label",
      datePrepared: "master-app-date-prepared-label",
      readOnlyMode: "read-only-mode-label",
      readOnlyModeMessage: "read-only-mode-message-label",
      excludedEmployee: "excluded-employee-label",
      dependentSurvivorBenefit: "dependent-survior-benefit-single-label",
      employeeNoWork: "employee-no-work-single-label",
      contractEmployeeSingle: "contract-employee-single-label"
    },
    census: {
      censusData: "census-data-label",
      youCanAddEmployeesByBulkCsvUpload: "you-can-add-employees-by-bulk-csv-upload-label",
      addEmployeesByBulkCsvUpload: "you-can-add-employees-by-bulk-csv-upload-label",
      requiredColumnsForCensusForm: "required-columns-for-census-form-label",
      uploadCensusForm: "upload-census-form-label",
      youMustProvideASheet: "you-must-provide-a-sheet-label",
      chooseTemplateFileType: "choose-template-file-type-label",
      viewDocumentExpanded: "view-document-expanded-label",
      selectCsvFiles: "select-csv-files-label",
      revisionNotice: "revision-notice-label",
      noCensusData: "no-census-data-label",
      successfulSubmission: "successful-submission-label",
      viewTemplate: "view-template-label",
      mustAlreadyBeCreated: "must-already-be-created-label",
      genderOptions: "gender-options-label",
      abbreviatedValues: "abbreviated-values-label",
      earningsTypeOptions: "earnings-type-options-label",
      salaryRequirement: "salary-requirement-label",
      hourlyRequirement: "hourly-requirement-label",
      dateFormat: "YYYY/MM/DD",
      planOptions: "plan-options-census-label",
      addEmployeesInstructions: "add-employeees-instructions-label",
      languageInstructions: "language-instructions-label",
      earnings: "earnings-census-label"
    },
    classesAndDivisions: {
      className: "class-name-label",
      classDescription: "class-description-label",
      divisionName: "divison-name-label",
      divisionDescription: "division-description-label",
      classTitleRequired: "class-title-required-label",
      classTitleLength: "class-title-length-label",
      descriptionLength: "description-length-label",
      removeClass: "remove-class-label",
      removalConfirmation: "class-removal-confirmation-label",
      removalConfirmationData: "class-removal-confirmation-data-label",
      classRestrictionQuestion: "class-restriction-question-label",
      title: "title-label",
      description: "description-label",
      managementHeader: "management-header-label",
      pricingNote: "pricing-note-label",
      managementNote: "management-note-label",
      reviewNote: "review-note-label",
      managementNoteDivision: "management-note-division-label",
      divisionTitleRequired: "division-title-required-label",
      divisionTitleLength: "division-title-length-label",
      descriptionLengthDivision: "description-length-label",
      removeDivision: "remove-division-label",
      removalConfirmationDivision: "removal-confirmation-label",
      revision: "revision-label",
      allDataForDivisionLost: "all-data-for-division-lost-label",
      name: "classes-divisions-name-label"
    },
    quotes: {
      noQuotes: "no-quotes-label",
      youDoNotHaveAnyQuotes: "you-do-not-have-any-quotes-label",
      isThisAsoGroup: "is-this-aso-group-label",
      quote: "qoutes-quote-label",
      revision: "quotes-revision-label",
      quoteSetup: "quote-setup-label",
      companyDetails: "company-details-label",
      requestReview: "request-review-label",
      convertQuote: "convert-quote-label",
      signingAuthorityApprovalPending: "signing-authority-approval-pending-label",
      quoteSold: "quote-sold-label",
      finalReviewStage: "final-review-stage-label",
      underwritingMessage: "underwriting-message-label",
      requestApprovalMessage: "request-approval-message-label",
      sentToSimplyBenefits: "sent-to-simply-benefits-label",
      simplyBenefitsApprovalPending: "simply-benefits-approval-pending-label",
      signingAuthorityAccepted: "signing-authority-accepted-label",
      convertQuoteToPendingAccount: "convert-quote-to-pending-account-label",
      pendingAccountCompletion: "pending-account-completion-label",
      reasonForRejectingPlans: "reason-for-rejecting-plans-label",
      noSavedRevisions: "no-saved-revisions-label",
      revisionReview: "revision-review-label",
      passedRevisions: "passed-revisions-label",
      revisionID: "revision-id-label",
      design: "design-label",
      changedBy: "changed-by-label",
      changedDate: "date-changed-label",
      accountLiveDate: "account-live-date-label",
      accountLiveSubmit: "account-live-submit-label",
      accountLiveReview: "account-live-review-label",
      effectiveDateEndMonth: "effective-date-end-month-label",
      accountUnderReview: "account-review-label",
      accountUnderReviewMemo: "account-review-memo-label",
      adminLanguage: "quote-admin-language-label",
      none: "quote-aso-none-label",
      healthAndDental: "quote-health-and-dental-label",
      dentalOnly: "quote-dental-only-label",
      healthOnly: "quote-health-only-label",
      inArrears: "quote-in-arrears-label",
      budgeted: "quote-budgeted-label"
    },
    accountHistory: {
      rateHistory: "rate-history-label",
      enterRateHistory: "enter-rate-history-label",
      claimsHistory: "claims-history-account-history-label",
      enterClaimsHistory: "enter-claims-history-label",
      uploadPastBill: "upload-past-bill-label",
      uploadSupportingDocuments: "upload-supporting-documents-label",
      uploadEmailsReceived: "upload-received-emails-label",
      uploadCensusRateClaimsHistory: "upload-census-rate-claims-history-label",
      selectCensusDocument: "select-census-document-label",
      pastBill: "past-bill-label",
      provideCensusDocument: "provide-census-document-label",
      emails: "account-history-emails-label",
      submitAccountHistory: "submit-account-history-label",
      selectRateHistoryDocument: "select-rate-history-document-label",
      // New phrase
      selectClaimsHistoryDocument: "select-claims-history-document-label",
      // New phrase
      selectPastBillDocument: "select-past-bill-document-label",
      // New phrase
      selectEmailDocument: "select-email-document-label",
      // New phrase
      selectSupportingDocuments: "select-supporting-documents-label"
    },
    planDesign: {
      welcomeToPlanDesignWizard: "plan-design-welcome-to-plan-design-wizard-label",
      standard: "plan-design-standard-label",
      traditionalPlanDesign: "plan-design-traditional-plan-design-structure-label",
      modularFlex: "plan-design-modular-flex-label",
      buildTieredOfferings: "plan-design-build-tiered-offerings-label",
      buttonBelowAccountType: "plan-design-button-below-account-type-label",
      modularFlexPlanDesign: "plan-design-modular-flex-plan-design-label",
      welcomeToModularFlexWizard: "plan-design-welcome-to-modular-flex-wizard-label",
      cannotBeUndone: "plan-design-cannot-be-undone-label",
      submitModularFlexDesigns: "plan-design-submit-modular-flex-designs-label",
      welcomeToPlanDesignWizardClass: "plan-design-welcome-to-plan-design-wizard-class-label",
      submitPlanDesigns: "plan-design-submit-plan-designs-label",
      successfullySubmittedModularFlexPlan: "plan-design-successfully-submitted-modular-flex-plan-label",
      successfullySubmittedPlanDesigns: "plan-design-successfully-submitted-plan-designs-label",
      moveOnToCommissionAssignment: "plan-design-move-on-to-commission-assignment-label",
      selectNextBelow: "plan-design-select-next-below-label",
      buildAQuote: "plan-design-build-a-quote-label",
      saveBlueprint: "plan-design-save-blueprint-label",
      planDesignsUnderReview: "plan-design-plan-designs-under-review-label",
      reviewFinishedNoPricing: "plan-design-review-finished-no-pricing-label",
      acceptPricingNoChanges: "plan-design-accept-pricing-no-changes-label",
      acceptedPricingChangesContact: "plan-design-accepted-pricing-changes-contact-label",
      changesMade: "plan-design-changes-made-label",
      unsavedChanges: "plan-design-unsaved-changes-label",
      planDesignChangesBackdated: "plan-design-plan-design-changes-backdated-label",
      addDesign: "plan-design-add-design-label",
      newBlankDesign: "plan-design-new-blank-design-label",
      cloneDesign: "plan-design-clone-design-label",
      uploadDesign: "plan-design-upload-design-label",
      viewRevisions: "plan-design-view-revisions-label",
      saveDesign: "plan-design-save-design-label",
      planDesignsCannotBeChanged: "plan-design-plan-designs-cannot-be-changed-label",
      noPlanDesignsForClass: "plan-design-no-plan-designs-for-class-label",
      clickNewButtonToStart: "plan-design-click-new-button-to-start-label",
      saveChangesConfirmation: "plan-design-save-changes-confirmation-label",
      uploadPlanDesignFile: "plan-design-upload-plan-design-file-label",
      lifeInsuranceCurrent: "plan-design-life-insurance-current-label",
      selectBetween: "plan-design-select-between-label",
      flatAmount: "plan-design-flat-amount-label",
      timesEarnings: "plan-design-times-earnings-label",
      completeFollowing: "plan-design-complete-following-label",
      nonEvidenceMaximum: "plan-design-non-evidence-maximum-label",
      maximumWithEvidence: "plan-design-maximum-with-evidence-label",
      reducesBy: "plan-design-reduces-by-label",
      reducesAtAge: "plan-design-reduces-at-age-label",
      completeSecondReduction: "plan-design-complete-second-reduction-label",
      secondReduction: "plan-design-second-reduction-label",
      secondReductionBy: "plan-design-second-reduction-by-label",
      secondReductionAtAge: "plan-design-second-reduction-at-age-label",
      planEligibilityTermination: "plan-design-plan-eligibility-termination-label",
      eligibilityPeriodMonths: "plan-design-eligibility-period-months-label",
      minimumHoursPerWeek: "plan-design-minimum-hours-per-week-label",
      additionalRequestsInformation: "plan-design-additional-requests-information-label",
      terminationAge: "plan-design-termination-age-label",
      accidentalDeathDismembermentCurrent: "plan-design-accidental-death-dismemberment-current-label",
      dependentLifeCurrent: "plan-design-dependent-life-current-label",
      childCoverage: "plan-design-child-coverage-label",
      spouseCoverage: "plan-design-spouse-coverage-label",
      shortTermDisabilityCurrent: "plan-design-short-term-disability-current-label",
      gradedAmount: "plan-design-graded-amount-label",
      percentageOfFlatAmount: "plan-design-percentage-of-flat-amount-label",
      percentageOfFirstMaximum: "plan-design-percentage-of-first-maximum-label",
      percentageOfSecondMaximum: "plan-design-percentage-of-second-maximum-label",
      percentageOfThirdMaximum: "plan-design-percentage-of-third-maximum-label",
      firstMaximumType: "plan-design-first-maximum-type-label",
      dollarAmount: "plan-design-dollar-amount-label",
      remainder: "plan-design-remainder-label",
      secondMaximumType: "plan-design-second-maximum-type-label",
      thirdMaximumType: "plan-design-third-maximum-type-label",
      benefitsPeriodWeeks: "plan-design-benefits-period-weeks-label",
      benefitsPeriod: "plan-design-benefits-period-label",
      eliminationPeriodSicknessDays: "plan-design-elimination-period-sickness-days-label",
      eliminationPeriodAccidentDays: "plan-design-elimination-period-accident-days-label",
      eliminationPeriodHospitalDays: "plan-design-elimination-period-hospital-days-label",
      firstMaximum: "plan-design-first-maximum-label",
      secondMaximum: "plan-design-second-maximum-label",
      thirdMaximum: "plan-design-third-maximum-label",
      longTermDisabilityCurrent: "plan-design-long-term-disability-current-label",
      allowPreExistingConditions: "plan-design-allow-pre-existing-conditions-label",
      allowCostOfLivingAdjustments: "plan-design-allow-cost-of-living-adjustments-label",
      costOfLivingAdjustmentPercentage: "plan-design-cost-of-living-adjustment-percentage-label",
      allowLumpSumPayment: "plan-design-allow-lump-sum-payment-label",
      twoYears: "plan-design-two-years-label",
      fiveYears: "plan-design-five-years-label",
      toAge65: "plan-design-to-age-65-label",
      eliminationPeriodDays: "plan-design-elimination-period-days-label",
      definitionOfDisability: "plan-design-definition-of-disability-label",
      criticalIllnessCurrent: "critical-illness-current-label",
      includeSpouseCI: "plan-design-include-spouse-ci-label",
      spouseFlatAmount: "plan-design-spouse-flat-amount-label",
      includeChildCI: "plan-design-include-child-ci-label",
      childFlatAmount: "plan-design-child-flat-amount-label",
      drugsCurrent: "plan-design-drugs-current-label",
      deductible: "plan-design-deductible-label",
      nonDeductible: "plan-design-non-deductible-label",
      amount: "plan-design-amount-label",
      equalToDispenseFee: "plan-design-equal-to-dispense-fee-label",
      gradedDrugScale: "plan-design-graded-drug-scale-label",
      reimbursement: "plan-design-reimbursement-label",
      drugPlanType: "plan-design-drug-plan-type-label",
      preferredProviderNetwork: "plan-design-preferred-provider-network-label",
      overallMaximumCalendarYear: "plan-design-overall-maximum-calendar-year-label",
      overallMaximum: "plan-design-overall-maximum-label",
      dispenseFeeMaximum: "plan-design-dispense-fee-maximum-label",
      erectileDysfunctionDrugs: "plan-design-erectile-dysfunction-drugs-label",
      edReimbursement: "plan-design-ed-reimbursement-label",
      edMaximum: "plan-design-ed-maximum-label",
      fertilityReimbursement: "plan-design-fertility-reimbursement-label",
      fertilityMaximumLifetime: "plan-design-fertility-maximum-lifetime-label",
      preventativeVaccines: "plan-design-preventative-vaccines-label",
      preventativeVaccinesMaximum: "plan-design-preventative-vaccines-maximum-label",
      preventativeVaccinesReimbursement: "plan-design-preventative-vaccines-reimbursement-label",
      smokingCessations: "plan-design-smoking-cessations-label",
      smokingCessationsReimbursement: "plan-design-smoking-cessations-reimbursement-label",
      smokingCessationsMaximumLifetime: "plan-design-smoking-cessations-maximum-lifetime-label",
      selectItemsIncluded: "plan-design-select-items-included-label",
      provider: "plan-design-provider-label",
      fertilityDrugs: "plan-design-fertility-drugs-label",
      selectMaximumTypes: "plan-design-select-maximum-types-label",
      healthcareCurrent: "plan-design-healthcare-current-label",
      majorHealth: "plan-design-major-health-label",
      combineMajorHealth: "plan-design-combine-major-health-label",
      combinedMajorHealthMaximum: "plan-design-combined-major-health-maximum-label",
      footOrthotics: "plan-design-foot-orthotics-label",
      orthopedicShoes: "plan-design-orthopedic-shoes-label",
      hearingAidsPeriodMonths: "plan-design-hearing-aids-period-months-label",
      dentalAccidents: "plan-design-dental-accidents-label",
      dentalAccidentsReimbursement: "plan-design-dental-accidents-reimbursement-label",
      glassesContactsCataractSurgery: "plan-design-glasses-contacts-cataract-surgery-label",
      cataractSurgeryEyewearPeriodMonths: "plan-design-cataract-surgery-eyewear-period-months-label",
      hospitalBenefitsType: "plan-design-hospital-benefits-type-label",
      hospitalBenefitsReimbursement: "plan-design-hospital-benefits-reimbursement-label",
      privateDutyNursing: "plan-design-private-duty-nursing-label",
      prosthetics: "plan-design-prosthetics-label",
      cardiacRehabilitation: "plan-design-cardiac-rehabilitation-label",
      apneaMachineCPAP: "plan-design-apnea-machine-cpap-label",
      artificialEyeLimbRepairReplacement: "plan-design-artificial-eye-limb-repair-replacement-label",
      bloodPressureMonitor: "plan-design-blood-pressure-monitor-label",
      compressionStockings: "plan-design-compression-stockings-label",
      glucoseMonitoringEquipmentSupplies: "plan-design-glucose-monitoring-equipment-supplies-label",
      insulinPump: "plan-design-insulin-pump-label",
      insulinPumpSupplies: "plan-design-insulin-pump-supplies-label",
      tensMachine: "plan-design-tens-machine-label",
      viscosupplementation: "plan-design-viscosupplementation-label",
      wheelchairManual: "plan-design-wheelchair-manual-label",
      wheelchairElectric: "plan-design-wheelchair-electric-label",
      wigs: "plan-design-wigs-label",
      includeConvalescentHospital: "plan-design-include-convalescent-hospital-label",
      convalescentHospitalReimbursement: "plan-design-convalescent-hospital-reimbursement-label",
      convalescentHospitalDailyMaximum: "plan-design-convalescent-hospital-daily-maximum-label",
      convalescentHospitalMaximumDays: "plan-design-convalescent-hospital-maximum-days-label",
      includeDiagnosticServices: "plan-design-include-diagnostic-services-label",
      diagnosticServicesMaximum: "plan-design-diagnostic-services-maximum-label",
      includeMedicalReferral: "plan-design-include-medical-referral-label",
      medicalReferralReimbursement: "plan-design-medical-referral-reimbursement-label",
      medicalReferralMaximum: "plan-design-medical-referral-maximum-label",
      perPractitioner: "plan-design-per-practitioner-label",
      combinedMaximum: "plan-design-combined-maximum-label",
      both: "plan-design-both-label",
      paramedicalReimbursement: "plan-design-paramedical-reimbursement-label",
      combinedParamedicalMaximum: "plan-design-combined-paramedical-maximum-label",
      applyAmountToAll: "plan-design-apply-amount-to-all-label",
      setPerPractitioner: "plan-design-set-per-practitioner-label",
      paramedicalMaximum: "plan-design-paramedical-maximum-label",
      combineByGroup: "plan-design-combine-by-group-label",
      divideAmountAmongProviders: "plan-design-divide-amount-among-providers-label",
      mentalWellnessReimbursement: "plan-design-mental-wellness-reimbursement-label",
      mentalWellnessMaximum: "plan-design-mental-wellness-maximum-label",
      divideAmountAmongPsychologistSocialWorker: "plan-design-divide-amount-among-psychologist-social-worker-test-label",
      groupMentalWellnessServices: "plan-design-group-mental-wellness-services-label",
      visionCare: "plan-design-vision-care-label",
      twelveMonthChildMaximum: "plan-design-twelve-month-child-maximum-label",
      twentyFourMonthAdultMaximum: "plan-design-twenty-four-month-adult-maximum-label",
      eyeGlassesContactLenses: "plan-design-eye-glasses-contact-lenses-label",
      medicallyRequiredContactLenses: "plan-design-medically-required-contact-lenses-label",
      eyeExams: "plan-design-eye-exams-label",
      survivorBenefitsMonths: "plan-design-survivor-benefits-months-label",
      diagnosticServicesReimbursement: "plan-design-diagnostic-services-reimbursement-label",
      outOfCountryPeriod: "plan-design-out-of-country-period-label",
      outOfCountryProvinceCurrent: "plan-design-out-of-country-province-current-label",
      coverageRolloverPeriod: "plan-design-coverage-rollover-period-label",
      medicalReferral: "plan-design-medical-referral-label",
      lifetimeCoverage: "plan-design-lifetime-coverage-label",
      isGraded: "plan-design-is-graded-label",
      reducedPeriodDays: "plan-design-reduced-period-days-label",
      employeeFamilyAssistanceProgramCurrent: "plan-design-employee-family-assistance-program-current-label",
      medicalSecondOpinion: "plan-design-medical-second-opinion-label",
      eldercare: "plan-design-eldercare-label",
      employeeFamilyAssistanceProgramDescription: "plan-design-employee-family-assistance-program-description-label",
      employeeAndFamilyAssistance: "plan-design-employee-and-family-assistance-label",
      coverage: "plan-design-coverage-label",
      selectItemsToInclude: "plan-design-select-items-to-include-label",
      virtualHealthcareCurrent: "plan-design-virtual-healthcare-current-label",
      virtualHealthcareDescription: "plan-design-virtual-healthcare-description-label",
      maple: "plan-design-maple-label",
      gotodoctor: "plan-design-gotodoctor-label",
      dialogue: "plan-design-dialogue-label",
      dentalCurrent: "plan-design-dental-current-label",
      combineBasicMajorMaximums: "plan-design-combine-basic-major-maximums-label",
      basicMajorMaximum: "plan-design-basic-major-maximum-label",
      basicReimbursement: "plan-design-basic-reimbursement-label",
      majorReimbursement: "plan-design-major-reimbursement-label",
      monthsToRecall: "plan-design-months-to-recall-label",
      unitsOfScaling: "plan-design-units-of-scaling-label",
      basicServices: "plan-design-basic-services-label",
      basicMaximum: "plan-design-basic-maximum-label",
      majorMaximum: "plan-design-major-maximum-label",
      orthodonticReimbursement: "plan-design-orthodontic-reimbursement-label",
      orthodonticLifetimeMaximum: "plan-design-orthodontic-lifetime-maximum-label",
      orthodonticTerminationAge: "plan-design-orthodontic-termination-age-label",
      majorServices: "plan-design-major-services-label",
      spendingAccountsCurrent: "plan-design-spending-accounts-current-label",
      combineHealthLifestyleSpendingMaximums: "plan-design-combine-health-lifestyle-spending-maximums-label",
      healthLifestyleSpendingMaximum: "plan-design-health-lifestyle-spending-maximum-label",
      allow1YearRollover: "plan-design-allow-1-year-rollover-label",
      healthSpendingRolloverMaximum: "plan-design-health-spending-rollover-maximum-label",
      setRolloverMaximum: "plan-design-set-rollover-maximum-label",
      lifestyleSpendingRolloverMaximum: "plan-design-lifestyle-spending-rollover-maximum-label",
      enableProrating: "plan-design-enable-prorating-label",
      typeOfProration: "plan-design-type-of-proration-label",
      enableQuarterlyAllowance: "plan-design-enable-quarterly-allowance-label",
      noteQuarterlyAllowance: "plan-design-note-quarterly-allowance-label",
      day: "plan-design-day-label",
      month: "plan-design-month-label",
      quarter: "plan-design-quarter-label",
      pleaseSelectPlanDesign: "please-select-plan-design-label",
      pleaseSelectPlanDesignRejectionWording: "please-select-plan-design-rejection-wording-label",
      clickContinueSalesNotification: "click-continue-sales-notification-label",
      clickContinuePlanAssignment: "click-continue-plan-assignment-label",
      rejectionReason: "rejection-reason-label",
      reviewAndSetPricing: "review-and-set-pricing-label",
      clickAcceptPricing: "click-accept-pricing-label",
      hideSummary: "hide-summary-label",
      viewSummary: "view-summary-label",
      divideAmongProviders: "divide-among-providers",
      earlyPaymentPrivilege: "plan-design-early-payment-privilege-label",
      isParamedicalFamilyCombinedMaximum: "plan-design-is-paramedical-family-combined-maximum",
      paramedicalFamilyCombinedMaximumAmount: "plan-design-paramedical-family-combined-maximum-amount"
    },
    marketplace: {
      optOutConfirmation: "marketplace-opt-out-confirmation-label",
      optOutConfirmationMessage: "marketplace-opt-out-confirmation-message-label",
      announcement: "marketplace-announcement-label",
      announcements: "marketplace-announcement-label",
      newProductsAnnouncement: "marketplace-new-products-announcement-label",
      learnMoreButton: "marketplace-learn-more-button-label",
      learnMoreButtonMultiple: "marketplace-learn-more-button-multiple-label",
      optInOutButton: "marketplace-opt-in-out-button-label",
      optOutWarning: "marketplace-opt-out-warning-label",
      optOutPhrase: "marketplace-opt-out-phrase-label",
      newProductAvailable: "marketplace-new-product-available-label",
      newProductsAvailable: "marketplace-new-products-available-label",
      additionalProductsInfo: "marketplace-additional-products-info-label",
      availableProducts: "marketplace-available-products-label",
      noProductsAvailable: "marketplace-no-products-available-label",
      enrolmentWindow: "marketplace-enrolment-window-label",
      downloadBrochure: "marketplace-download-brochure-label",
      primaryPolicyNumber: "marketplace-primary-policy-number-label",
      member: "marketplace-member-label",
      coverage: "marketplace-coverage-label",
      monthlyFee: "marketplace-monthly-fee-label",
      terminateOnDate: "marketplace-terminate-on-date-label",
      dependentCoverage: "marketplace-dependent-coverage-label",
      spouseCoverage: "marketplace-spouse-coverage-label",
      coverageDetails: "marketplace-coverage-details-label",
      terminateCoverage: "marketplace-terminate-coverage-label",
      noProductsPurchased: "marketplace-no-products-purchased-label",
      myProducts: "marketplace-my-products-label",
      carrier: "marketplace-carrier-label",
      gst: "marketplace-gst-label",
      hst: "marketplace-hst-label",
      childCoverage: "marketplace-child-coverage-label",
      pricingInCoverage: "marketplace-pricing-in-coverage-label",
      welcomeToMarketplace: "welcome-to-marketplace-label",
      selectedProductInfo: "selected-product-info-label",
      productSeparateInfoVoluntary: "product-separate-info-label-voluntary",
      productSeparateInfoOptional: "product-separate-info-label-optional",
      coverageEffectiveDateInfo: "coverage-effective-date-info-label",
      invoiceInfoVoluntary: "invoice-info-voluntary-label",
      invoiceInfoOptional: "invoice-info-optional-label",
      productChangeInfoVoluntary: "product-change-info-label-Voluntary",
      productChangeInfoOptional: "product-change-info-label-Optional",
      disclosureInfo: "disclosure-info-label",
      selectOptionInfo: "select-option-info-label",
      selectCoverage: "select-coverage-label",
      selectCoverageAmountVoluntary: "select-coverage-amount-label-voluntary",
      selectCoverageAmountOptional: "select-coverage-amount-label-optional",
      monthlyCost: "monthly-cost-label",
      perMonth: "per-month-label",
      purchaseDependentCoverage: "purchase-dependent-coverage-label",
      dependentCoverageAmount: "dependent-coverage-amount-label",
      purchaseSpouseCoverage: "purchase-spouse-coverage-label",
      paymentWithdrawalInfoVoluntary: "payment-withdrawal-info-label-voluntary",
      paymentWithdrawalInfoOptional: "payment-withdrawal-info-label-optional",
      spouseCoverageAmount: "spouse-coverage-amount-label",
      purchaseChildCoverage: "purchase-child-coverage-label",
      childCoverageAmount: "child-coverage-amount-label",
      reviewProductDetailsVoluntary: "review-product-details-label-voluntary",
      reviewProductDetailsOptional: "review-product-details-label-optional",
      terminationBlocked: "termination-blocked-info-label",
      terminationInfo: "termination-info-label",
      paymentWithdrawalReviewInfo: "payment-withdrawal-review-info-label",
      benefitsEffectiveDateInfo: "benefits-effective-date-info-label",
      purchaseWithinTimePeriod: "purchase-within-time-period-label",
      coverageEffectiveDate: "marketplace-coverage-effective-date-label",
      agreement: "marketplace-agreement-label",
      confirmPurchaseInfo: "confirm-purchase-info-label",
      selectCoverageAmountInfo: "select-coverage-amount-info-label",
      yourCoverageAmount: "your-coverage-amount-label",
      productTotal: "product-total-label",
      transactionHistory: "transaction-history-label",
      viewMonthlyPayments: "view-monthly-payments-label",
      hideHistory: "hide-history-label",
      viewHistory: "view-history-label",
      noPastTransactions: "no-past-transactions-label",
      terminateCoverageInfo: "terminate-coverage-info-label",
      withdrawalAgreementInfoVoluntary: "withdrawal-agreement-info-label-voluntary",
      withdrawalAgreementInfoOptional: "withdrawal-agreement-info-label-optional",
      marketplaceProduct: "marketplace-product-label",
      downloadReceipts: "download-receipts-for-each-monthly-label",
      hideTransactionHistory: "marketplace-hide-transaction-history-label",
      viewTransactionHistory: "marketplace-view-transaction-history-label",
      applyAsCarryForward: "marketplace-apply-as-carry-forward-label",
      noPaymentsApplied: "marketplace-no-payments-applied-label",
      yourProducts: "marketplace-your-products-label",
      terminateProduct: "marketplace-terminate-product-label",
      byClickingTerminate: "marketplace-by-clicking-terminate-label",
      thisCannotBeUndone: "marketplace-this-cannot-be-undone-label",
      pleaseEnterPasswordToTerminateProduct: "marketplace-please-enter-password-to-terminate-product-label",
      welcomeToTheSimplyBenefitsMarketplace: "marketplace-welcome-to-the-marketplace-label",
      youHaveSelected: "marketplace-you-have-selected-label",
      "with": 'marketplace-with-label',
      beforeYouGetStarted: "marketplace-before-you-get-started-label",
      voluntary: "marketplace-product-voluntary-type",
      optional: "marketplace-product-optional-type",
      optionalVsVoluntary: "optional-vs-Voluntary",
      optionalVsVoluntaryDesc: "optional-vs-Voluntary-description"
    },
    benefitCard: {
      benefits: "benefitCard-benefits-label",
      cutOut: "benefitCard-cut-out-label"
    },
    pricing: {
      rate: "pricing-rate-label",
      carrier: "pricing-carrier-label",
      extendedHealthCare: "pricing-extended-healthcare-label",
      solo: "pricing-solo-label",
      duo: "pricng-duo-label",
      family: "pricng-family-label"
    },
    proofOfInsurance: {
      graded: "proof-of-insurance-graded-label",
      flatAmount: "proof-of-insurance-flat-amount-label",
      "per calendar year": "proof-of-insruance-per-cal-year-label",
      noMaximum: "proof-of-insurance-no-maximum-label",
      mentalWellness: "proof-of-insurance-mental-wellness-label",
      "insured through provincial": "proof-of-insurance-insured-through-label",
      employeeData: "proof-of-insurance-employee-data-label",
      employer: "proof-of-insurance-employer-label",
      group: "proof-of-insurance-group-label",
      dateOfBirth: "proof-of-insurance-date-of-birth-label",
      insurableEarnings: "proof-of-insurance-insurable-earnings-label",
      benefit: "proof-of-insurance-benefit-label",
      basicReimbursement: "proof-of-insurance-basic-reimbursement-label",
      majorReimbursement: "proof-of-insurance-major-reimbursement-label",
      basicAndMajor: "proof-of-insurance-basic-and-major-label",
      basicMaximum: "proof-of-insurance-basic-max-label",
      majorMaximum: "proof-of-insurance-major-max-label",
      orthoCoverage: "proof-of-insurance-ortho-coverage-label",
      childrenAndAdults: "proof-of-insurance-children-adults-label",
      children: "proof-of-insurance-children-label",
      recalls: "proof-of-insurance-recalls-label",
      unitsOfScaling: "proof-of-insurance-units-of-scaling-label",
      accountEffectiveDate: "proof-of-insurance-account-effective-label",
      employeeEffectiveDate: "proof-of-insurance-employee-effective-label",
      name: "proof-of-insurance-name-label",
      fullLegalName: "proof-of-insurance-full-legal-name-label",
      info1: "proof-of-insurance-info-1-label",
      info2: "proof-of-insurance-info-2-label",
      bonus: "proof-of-insurance-bonus-label",
      employee: "proof-of-insurance-employee-label",
      datePrepared: "proof-of-insurance-date-prepared-label",
      employeeID: "proof-of-insurance-employeeID-label"
    },
    claimSummary: {
      "for the period": "claim-summary-for-the-period-label",
      datePrepared: "claim-summary-date-prepared-label",
      employeeData: "claim-summary-employee-data-label",
      planMember: "claim-summary-plan-member-name-label",
      amountPaid: "claim-summary-amount-paid-label",
      amountSubmitted: "claim-summary-amount-submitted-label",
      paymentDate: "claim-summary-payment-date-label",
      serviceDate: "claim-summary-serivce-date-label",
      details: "claim-summary-details-label",
      status: "claim-summary-status-label",
      benefitType: "claim-summary-benefit-type-label",
      to: "claim-summary-to-label",
      description: "claim-summary-description-label",
      date: "claim-summary-date-label",
      submitted: "claim-summary-submitted-label",
      deductible: "claim-summary-deductible-label",
      coinsurance: "claim-summary-coinsurance-label",
      covered: "claim-summary-coinsurance-covered",
      din: "claim-summary-din-covered",
      hsa: "claim-summary-hsa-covered",
      procedure: "claim-summary-procedure-covered",
      surface: "claim-summary-surface-covered",
      claimNumber: "claim-summary-claim-number-label",
      patient: "claim-summary-patient-label",
      certHolder: "claim-summary-cert-holder-label",
      benefitsSalaryRated: "claim-summary-benefits-salary-rated-label",
      dependent: "claim-summary-dependent-label",
      primary: "claim-summary-primary-label",
      dentalClaimDetails: "claim-summarh-dental-laebl",
      extendedHealthDetails: "claim-summary-extended-label",
      explantionBenefits: "claim-summary-explantation-label",
      coordinationBenefits: "claim-summary-coordination-label",
      ifApplicable: "claim-summary-if-applicable-laebl",
      adjudicationNotes: "claim-summary-adjudication-notes-label",
      totalSubmittedFirstPayor: "claim-summary-total-submitted-first-payor-label",
      totalPaidFirstPayor: "claim-summary-total-paid-first-payor-label",
      amountNotCoveredFirstPayor: "claim-summary-amount-not-covered-label",
      totalAmountSubmittedSB: "claim-summary-total-amount-submitted-sb-label",
      healthSpendingTopOff: "claim-summary-hsa-top-off-label",
      totalPaidSB: "claim-summary-total-paid-sb-label",
      amountNotCoveredSB: "claim-summary-amount-not-covered-sb-label",
      totalSubmitted: "claim-summary-total-submitted-label",
      totalPaid: "claim-summary-total-paid-label",
      totalNotCovered: "claim-summary-total-not-covered-label",
      aboveInformation: "claim-summary-above-info-label"
    },
    aso: {
      claimsPeriod: "claims-period-label",
      datePrepared: "date-prepared-label",
      asoAccountSummary: "aso-account-summary-label",
      revenue: "revenue-label",
      asoBalanceAdjustment: "aso-balance-adjustments-label",
      asoStopLossAdjustment: "aso-stop-loss-adjustments-label",
      benefitAdjustment: "benefit-adjustments-label",
      netPremiumBilled: "net-premium-billed-label",
      grossPremiumBilled: "gross-premium-billed-label",
      expenses: "expenses-label",
      claimPaidUnderAso: "claims-paid-under-aso-label",
      managementFee: "management-fee-label",
      adminFee: "administration-fee-label",
      appTaxesHstGst: "applicable-taxes-hst-gst-label",
      appTaxes: "applicable-taxes-label",
      totalExpenses: "total-expenses-label",
      gainLoss: "gains-loss-for-period-label",
      balanceAsoAccount: "balance-in-aso-account-label",
      interestRate: "interest-rate-label",
      interestEarned: "interest-earned-label",
      feeDental: "fee-dental-label",
      feeHealth: "fee-health-label",
      adminFeeDental: "admin-fee-dental-label",
      adminFeeHealth: "admin-fee-health-label",
      basedOnClaims: "based-on-claims-label",
      hstGst: "hst-gst-label",
      balanceInAso: "balance-in-aso-account-assumes-net-premium-billed-paid-in-full-label",
      priorBalance: "prior-balance-label",
      asoAdjustments: "aso-adjustments-label",
      numLivesSolo: "number-of-lives-solo-label",
      numLivesDuo: "number-of-lives-duo-label",
      numLivesFamily: "number-of-lives-family-label",
      asoDivisionSummary: "aso-reconciliation-division-summary-label"
    },
    amendments: {
      accountHasNoAmendments: "account-has-no-amendments-label",
      amendment: "amendments-amendment-label",
      agent: "amendments-agent-label",
      updated: "amendments-updated-label",
      effective: "amendments-effective-label",
      requestedChanges: "amendments-requested-changes-label",
      soloRateCurrent: "amendments-solo-rate-label",
      duoRateCurrent: "amendments-duo-rate-label",
      familyRateCurrent: "amendments-family-rate-label",
      soloRateNew: "amendments-solo-rate-new-label",
      duoRateNew: "amendments-duo-rate-new-label",
      familyRateNew: "amendments-family-rate-new-label",
      inProgress: "amendments-in-progress-label",
      amendmentCurrentlyInProgress: "amendment-currently-in-progress-label",
      amendmentFormUnderReview: "amendment-form-under-review-label",
      amendmentSentToSigningAuth: "amendment-form-sent-to-signing-auth-label",
      amendmentFormApproved: "amendment-form-approved-label",
      amendmentFormApprovedBySigningAuth: "amendment-approved-by-signing-auth-label",
      amendmentFormUnderRevision: "amendment-form-under-revision-label",
      amendmentCurrentlyUnderRevisions: "amendment-currently-under-revisions-label",
      amendmentPending: "amendment-pending-label",
      amendmentHasBeenApprovedChangesPending: "amendment-approved-changes-pending-label",
      amendmentCompleted: "amendment-comleted-label",
      amendmentApproved: "amendment-approved-label",
      accountDetailChanges: "amendments-account-detail-changes-label",
      classChanges: "amendments-class-changes-label",
      divisionChanges: "amendments-division-changes-label",
      adminFeeChanges: "amendments-admin-fee-changes-label",
      benefitChanges: "amendments-benefit-changes-label",
      followingClassesWillBeAmended: "amendments-following-changes-will-be-amended-label",
      signingAuthoritySignature: "amendments-signing-authority-signatures-label",
      amendmentAcknowledgement: "amendments-acknowledgement-label",
      amendmentApprovedMemo: "amendment-approved-memo-label",
      amendmentYouAlreadySigned: "amendment-already-signed-label",
      amendmentPleaseReview: "amendment-please-review",
      amendmentForm: "amendment-form-label",
      amendmentDetails: "amendment-details-label"
    },
    tiles: {
      accountHistory: 'tiles-accountHistory'
    },
    files: {
      deleteMessage: "files-deleteMessage",
      tableHeadings: {
        name: "files-tableHeadings-name",
        owner: "files-tableHeadings-owner",
        lastModified: "files-tableHeadings-lastModified",
        fileSize: "files-tableHeadings-fileSize"
      },
      menu: {
        open: 'files-menu-open',
        "delete": 'files-menu-delete'
      },
      owners: {
        member: 'files-owners-member',
        agent: 'files-owners-agent',
        account: 'files-owners-account',
        advisor: 'files-owners-advisor',
        admin: 'files-owners-admin'
      },
      inputs: {
        folderName: 'files-inputs-folderName'
      }
    }
  },
  dropdowns: {
    provinces: {
      alberta: 'dropdowns-provinces-alberta',
      "british columbia": 'dropdowns-provinces-british-columbia',
      manitoba: 'dropdowns-provinces-manitoba',
      "new brunswick": 'dropdowns-provinces-new-brunswick',
      "newfoundland and labrador": 'dropdowns-provinces-newfoundland',
      "northwest territories": 'dropdowns-provinces-northwest-territories',
      "nova scotia": 'dropdowns-provinces-nova-scotia',
      nunavut: 'dropdowns-provinces-nunavut',
      ontario: 'dropdowns-provinces-ontario',
      "prince edward island": 'dropdowns-provinces-prince-edward-island',
      quebec: 'dropdowns-provinces-quebec',
      saskatchewan: 'dropdowns-provinces-saskatchewan',
      yukon: 'dropdowns-provinces-yukon'
    },
    coverageTypes: {
      'solo': 'dropdowns-coverageTypes-solo',
      'duo': 'dropdowns-coverageTypes-duo',
      'family': 'dropdowns-coverageTypes-family',
      'waive': 'dropdowns-coverageTypes-waive'
    },
    relationships: {
      child: 'dropdowns-relationships-child',
      spouse: 'dropdowns-relationships-spouse',
      parent: 'dropdowns-relationships-parent',
      sibling: 'dropdowns-relationships-sibling',
      grandparent: 'dropdowns-relationships-grandParent',
      grandchild: 'dropdowns-relationships-grandChild',
      'common law': 'dropdowns-relationships-common-law'
    },
    genders: {
      male: 'dropdowns-genders-male',
      female: 'dropdowns-genders-female',
      other: 'dropdowns-genders-other'
    },
    maritalStatuses: {
      'never married': 'dropdowns-marital-statuses-never-married',
      married: 'dropdowns-marital-statuses-married',
      'common law': 'dropdowns-marital-statuses-common-law',
      divorced: 'dropdowns-marital-statuses-divorced',
      widowed: 'dropdowns-marital-statuses-widowed',
      separated: 'dropdowns-marital-statuses-separated'
    },
    beneficiaries: {
      revocable: "dropdowns-revocable",
      irrevocable: "dropdowns-irrevocable"
    },
    benefits: {
      chiropractor: "dropdowns-chiropractor",
      registeredMassage: "dropdowns-registered-massage",
      massage: "dropdowns-massage",
      naturopath: "dropdowns-naturopath",
      osteopath: "dropdowns-osteopath",
      physiotherapy: "dropdowns-physiotherapy",
      podiatrist: "dropdowns-podiatrist",
      psychologist: "dropdowns-psychologist",
      speechTherapy: "dropdowns-speech-therapy",
      socialWorker: "dropdowns-social-worker",
      acupuncturist: "dropdowns-acupuncturist",
      chiropodist: "dropdowns-chiropodist",
      audiologist: "dropdowns-audiologist",
      registeredDietician: "dropdowns-registered-dietician",
      occupationalTherapist: "dropdowns-occupational-therapist",
      privateDutyNursing: "dropdowns-private-duty-nursing",
      hospitalBenefits: "dropdowns-hospital-benefits",
      ambulanceServices: "dropdowns-ambulance-services",
      orthotics: "dropdowns-orthotics",
      prosthetics: "dropdowns-prosthetics",
      hearingAids: "dropdowns-hearing-aids",
      medicalServicesAndSupplies: "dropdowns-medical-services-and-supplies",
      medicalEquipment: "dropdowns-medical-equipment",
      apneaMachineCPAP: "dropdowns-apnea-machine",
      apneaMachineSupplies: "dropdowns-apnea-machine-supplies",
      apneaMask: "dropdowns-apnea-mask",
      artificialEyeLimb: "dropdowns-artificial-eye-limb",
      artificialEyeLimbRepairReplacement: "dropdowns-artificial-eye-limb-repair-replacement",
      bloodPressureMonitor: "dropdowns-blood-pressure-monitor",
      bracesWithRigidSupports: "dropdowns-braces-with-rigid-supports",
      compressionStockings: "dropdowns-compression-stockings",
      crutches: "dropdowns-crutches",
      bloodGlucoseMonitoringEquipment: "dropdowns-blood-glucose-monitoring-equipment",
      bloodGlucoseMonitoringSupplies: "dropdowns-blood-glucose-monitoring-supplies",
      insulinPump: "dropdowns-insulin-pump",
      ippBreathingMachine: "dropdowns-ipp-breathing-machine",
      ostomySupplies: "dropdowns-ostomy-supplies",
      surgicalBra: "dropdowns-surgical-bra",
      tensMachine: "dropdowns-tens-machine",
      viscosupplementation: "dropdowns-viscosupplementation",
      wheelchairManual: "dropdowns-wheelchair-manual",
      wheelchairElectric: "dropdowns-wheelchair-electric",
      wigs: "dropdowns-wigs",
      cardiacRehabilitation: "dropdowns-cardiac-rehabilitation",
      convalescentHospital: "dropdowns-convalescent-hospital",
      erectileDysfunctionDrugs: "dropdowns-erectile-dysfunction-drugs",
      fertilityDrugs: "dropdowns-fertility-drugs",
      preventativeVaccine: "dropdowns-preventative-vaccine",
      smokingCessation: "dropdowns-smoking-cessation",
      genericDrugs: "dropdowns-generic-drugs",
      routineCare: "dropdowns-routine-care",
      periodontics: "dropdowns-periodontics",
      endodontics: "dropdowns-endodontics",
      dentures: "dropdowns-dentures",
      bridgeWork: "dropdowns-bridge-work",
      crowns: "dropdowns-crowns",
      orthodontics: "dropdowns-orthodontics",
      eyeExam: "dropdowns-eye-exam",
      eyeGlassesContacts: "dropdowns-eye-glasses-and-contacts",
      requiredSafetyEyewear: "dropdowns-required-safety-eyewear"
    },
    categoryOptions: {
      'drugs': 'dropdowns-categories-drugs',
      'dental': 'dropdowns-categories-dental',
      'health': 'dropdowns-categories-health',
      'paramedicals': 'dropdowns-categories-paramedicals',
      'vision': 'dropdowns-categories-vision'
    },
    nemOptions: {
      'life': 'dropdowns-nem-life',
      'add': 'dropdowns-nem-add',
      'std': 'dropdowns-nem-std',
      'ltd': 'dropdowns-nem-ltd'
    },
    earningsTypes: {
      hourly: "dropdowns-earningstypes-hourly",
      salary: "dropdowns-earningstypes-salary"
    },
    spendingAccounts: {
      hsa: "dropdowns-spendingaccounts-hsa",
      lsa: "dropdowns-spendingaccounts-lsa",
      all: "dropdowns-spendingaccounts-all"
    },
    healthDentalOptions: {
      health: "dropdowns-healthdentaloptions-health",
      dental: "dropdowns-healthdentaloptions-dental",
      both: "dropdowns-healthdentaloptions-both"
    },
    planMaximumOptions: {
      dollarAmount: "dropdowns-plan-maximum-options-dollar-amount",
      remainder: "dropdowns-plan-maximum-options-remainder"
    },
    defOfDisabilityOptions: {
      twoYears: "dropdowns-def-of-disability-options-two-years",
      fiveYears: "dropdowns-def-of-disability-options-five-years",
      toAge65: "dropdowns-def-of-disability-options-to-age-65"
    },
    defOfDisabilityMapOptions: {
      twoYearOwn: "dropdowns-def-of-disability-map-options-two-year-own",
      twoYearOwnHybrid: "dropdowns-def-of-disability-map-options-two-year-own-hybrid",
      fiveYearOwn: "dropdowns-def-of-disability-map-options-five-year-own"
    },
    drugsMaximumTypes: {
      dollarAmount: "dropdowns-drugs-maximums-types-dollar-amount",
      unlimited: "dropdowns-drugs-maximums-types-unlimited"
    },
    genericSubstituteTypes: {
      brandName: "dropdowns-generic-substitute-types-brand-name",
      mandatoryGeneric: "dropdowns-generic-substitue-mandatory-generic",
      genericSubstitute: "dropdowns-generic-substitute-generic"
    },
    preferredProvider: {
      other: "dropdowns-preferred-provider-other",
      costco: "dropdowns-preferred-provider-costco",
      pocketPills: "dropdowns-preferred-provider-pocket-pills",
      costcoAndPocketPills: "dropdowns-preferred-provider-both"
    },
    hospitalBenefitsTypes: {
      "private": "dropdowns-hospital-benefits-types-private",
      semiPrivate: "dropdowns-hospital-benefits-types-semi-private"
    },
    commission: {
      all: "dropdowns-all",
      paid: "dropdowns-paid",
      pending: "dropdowns-pending",
      failed: "dropdowns-failed"
    },
    languages: {
      english: "dropdowns-languages-english",
      french: "dropdowns-languages-french"
    },
    rolloverPeriod: {
      lifetime: "dropdowns-lifetime",
      calendarYear: "dropdowns-calendar-year",
      perTrip: "dropdowns-per-trip"
    },
    coveragePeriod: {
      thirtyDays: "drowpdowns-30-day",
      sixtyDays: "drowpdowns-60-days",
      ninetyDays: "dropdown-90-days",
      oneTwentyDays: "dropdown-120-days",
      oneEightyDays: "dropdown-180-days"
    }
  }
};